/* Invincible Human: original Muse component UI. Source layout/content retained.
   Provider analytics, cookies, cart, checkout, account and form scripts excluded. */
(function(){'use strict';
var originalMuseModules={
"home":function(document,window){
try {

(function() {
  'use strict';



  var sectionId = 'template--26315190534511__home_hero_banner_U9cpY6';
  var container = document.querySelector('.hero-banner-' + sectionId);
  if (!container) return;

  var slides = container.querySelectorAll('.hero-slide');
  var tagButtons = container.querySelectorAll('.hero-tag-btn');
  var progressBar = container.querySelector('[data-progress-bar]');
  var autoplayDelay = parseInt(container.dataset.autoplayDelay, 10) || 5000;
  var transitionDuration = 800;
  var currentIndex = 0;
  var isTransitioning = false;
  var autoplayTimer = null;

  function updateActiveState(index) {
    // Update slides
    slides.forEach(function(slide, i) {
      slide.classList.toggle('is-active', i === index);
    });

    // Update tag buttons — adds/removes .is-active automatically
    tagButtons.forEach(function(btn, i) {
      var isActive = i === index;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    currentIndex = index;
  }

  function goToSlide(index) {
    if (isTransitioning || index === currentIndex || index < 0 || index >= slides.length) return;
    isTransitioning = true;
    updateActiveState(index);
    resetAutoplay();
    setTimeout(function() {
      isTransitioning = false;
    }, transitionDuration);
  }

  function nextSlide() {
    var next = (currentIndex + 1) % slides.length;
    goToSlide(next);
  }

  function startProgress() {
    if (!progressBar) return;
    progressBar.classList.remove('is-animating');
    void progressBar.offsetWidth;
    progressBar.classList.add('is-animating');
  }

  function resetProgress() {
    if (!progressBar) return;
    progressBar.classList.remove('is-animating');
  }

  function startAutoplay() {
    if (slides.length <= 1) return;
    startProgress();
    autoplayTimer = setInterval(function() {
      nextSlide();
      startProgress();
    }, autoplayDelay);
  }

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    resetProgress();
    startAutoplay();
  }

  function stopAutoplay() {
    clearInterval(autoplayTimer);
    resetProgress();
  }

  // Click → go to clicked slide, tag gets .is-active
  tagButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var index = parseInt(this.dataset.slideIndex, 10);
      goToSlide(index);
    });
  });

  // Keyboard arrows
  tagButtons.forEach(function(btn) {
    btn.addEventListener('keydown', function(e) {
      var index = parseInt(this.dataset.slideIndex, 10);
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        var next = (index + 1) % tagButtons.length;
        tagButtons[next].focus();
        goToSlide(next);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        var prev = (index - 1 + tagButtons.length) % tagButtons.length;
        tagButtons[prev].focus();
        goToSlide(prev);
      }
    });
  });

  // Pause on hover, resume on leave
  container.addEventListener('mouseenter', stopAutoplay);
  container.addEventListener('mouseleave', startAutoplay);

  // Touch swipe
  var touchStartX = 0;
  container.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoplay();
  }, { passive: true });

  container.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        goToSlide((currentIndex + 1) % slides.length);
      } else {
        goToSlide((currentIndex - 1 + slides.length) % slides.length);
      }
    }
    startAutoplay();
  }, { passive: true });

  // Init
    // Init with random slide
  
  

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateActiveState(0);
      startAutoplay();
    });
  } else {
    updateActiveState(0);
    startAutoplay();
  }

})();


} catch (error) { console.warn("Muse source module home-0", error); }
try {

document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-home-products]');
  if (!container) return;

  var views = Array.from(container.querySelectorAll('[data-product-view]'));

  /* ── Update ATC button variant IDs when color changes ── */
  function updateAddToCart(view, variantType) {
    var selectedInput = view.querySelector('.color-option[data-showcase-variant="' + variantType + '"] input:checked');
    if (!selectedInput) return;
    view.querySelectorAll('[data-add-to-cart-redirect][data-showcase-variant="' + variantType + '"]').forEach(function(btn) {
      btn.setAttribute('data-product_id', selectedInput.value);
      btn.setAttribute('data-variant-id', selectedInput.value);
    });
  }

  // Initialise each view with the checked colour for both variants
  views.forEach(function(view) {
    updateAddToCart(view, 'bundle');
    updateAddToCart(view, 'solo');
  });

  /* ── Update scroll-video CTA link based on active product/variant ── */
  function updateScrollVideoCta() {
    var cta = document.querySelector('[data-shop-cta]');
    if (!cta) return;
    var activeView = document.querySelector('.home-products-section__view.is-active');
    if (!activeView) return;
    var productView = activeView.getAttribute('data-product-view') || '1';
    var selectedVariant = activeView.getAttribute('data-showcase-selected') || 'bundle';
    cta.href = document.documentElement.dataset.ihFocusRoute || '/#ih-service-focus';
    cta.textContent = 'View Focus program';
  }
  updateScrollVideoCta();

  /* ── Product view switcher ── */
  container.addEventListener('click', function (e) {
    var switcher = e.target.closest('[data-switch-to]');
    if (!switcher) return;

    var target = switcher.getAttribute('data-switch-to');

    views.forEach(function (view) {
      var isTarget = view.getAttribute('data-product-view') === target;
      view.classList.toggle('is-active', isTarget);
    });

    // When switching to a product, auto-select the "bundle" variant
    var activeView = document.querySelector('.home-products-section__view.is-active');
    if (activeView) {
      var bundleTab = activeView.querySelector('.variant-tab[data-variant-tab="bundle"]');
      if (bundleTab) bundleTab.click();
    }

    // Immediately sync sticky content for the new product
    if (typeof window.updateHomeSticky === 'function') {
      window.updateHomeSticky();
    }
    updateScrollVideoCta();
  });

  /* ── Global variant-tab sync ── */
  window.syncAllIndicatorsAndTabs = function(selectedVariant) {
    document.querySelectorAll('.switch-btns').forEach(function(group) {
      var tabs = group.querySelectorAll('.variant-tab');
      var indicator = group.querySelector('.switch-indicator');
      tabs.forEach(function(t, i) {
        var isSelected = t.getAttribute('data-variant-tab') === selectedVariant;
        t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected && indicator) {
          indicator.style.transform = 'translateX(' + (i * 100) + '%)';
        }
      });
    });
  };

  /* ── Variant toggle (solo / bundle) ── */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-variant-tab]');
    if (!tab) return;

    var selectedVariant = tab.getAttribute('data-variant-tab');

    // Sync all indicators & aria-selected across every .switch-btns group
    syncAllIndicatorsAndTabs(selectedVariant);

    // Find the active view
    var activeView = document.querySelector('.home-products-section__view.is-active');
    if (activeView) {
      activeView.setAttribute('data-showcase-selected', selectedVariant);

      // Sync bg image for the newly visible variant's color
      var checkedInput = activeView.querySelector('.color-option[data-showcase-variant="' + selectedVariant + '"] input:checked');
      if (checkedInput) {
        var colorLabel = checkedInput.closest('.color-option');
        var bgEl = activeView.querySelector('.home-products-section__bg');
        var color = colorLabel.getAttribute('data-color');
        if (color === 'carbon') {
          var isMobile = window.innerWidth <= 768;
          bgEl.style.backgroundImage = isMobile
            ? "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Mobile_54283439-560d-4e7f-9316-b7c0eddffc3c.jpg?v=1782854548')"
            : "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Web_888d2b26-6ab8-48fd-a100-08d2f4fccc48.jpg?v=1782854547')";
        } else {
          var desktop = bgEl.getAttribute('data-bg-desktop');
          var mobile = bgEl.getAttribute('data-bg-mobile');
          var isMobile = window.innerWidth <= 768;
          if (isMobile && mobile) {
            bgEl.style.backgroundImage = "url('" + mobile + "')";
          } else if (desktop) {
            bgEl.style.backgroundImage = "url('" + desktop + "')";
          } else {
            bgEl.style.backgroundImage = '';
          }
        }
      }
    }

    // Sync sticky bar content
    if (typeof window.updateHomeSticky === 'function') {
      setTimeout(window.updateHomeSticky, 50);
    }
    updateScrollVideoCta();
  });

  /* ── Color swatch change ── */
  container.addEventListener('change', function (e) {
    var input = e.target.closest('.color-option input');
    if (!input) return;

    var view = input.closest('[data-product-view]');
    if (!view) return;

    var variantType = input.closest('.color-option').getAttribute('data-showcase-variant');

    // Toggle is-checked on sibling labels
    view.querySelectorAll('.color-option input[name="' + input.name + '"]').forEach(function (el) {
      el.closest('.color-option').classList.toggle('is-checked', el.checked);
    });

    updateAddToCart(view, variantType);

    /* ── Update background image on color change ── */
    var colorLabel = input.closest('.color-option');
    if (colorLabel) {
      var bgEl = view.querySelector('.home-products-section__bg');
      var color = colorLabel.getAttribute('data-color');
      if (color === 'carbon') {
        var isMobile = window.innerWidth <= 768;
        bgEl.style.backgroundImage = isMobile
          ? "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Mobile.jpg?v=1782474367')"
          : "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Web.jpg?v=1782474356')";
      } else {
        /* restore opal defaults from data attributes */
        var desktop = bgEl.getAttribute('data-bg-desktop');
        var mobile = bgEl.getAttribute('data-bg-mobile');
        var isMobile = window.innerWidth <= 768;
        if (isMobile && mobile) {
          bgEl.style.backgroundImage = "url('" + mobile + "')";
        } else if (desktop) {
          bgEl.style.backgroundImage = "url('" + desktop + "')";
        } else {
          bgEl.style.backgroundImage = '';
        }
      }
    }
  });

  /* ── Responsive background image on resize ── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-product-view]').forEach(function (view) {
        var bgEl = view.querySelector('.home-products-section__bg');
        if (!bgEl) return;
        var checkedLabel = view.querySelector('.color-option.is-checked');
        if (!checkedLabel) return;
        var color = checkedLabel.getAttribute('data-color');
        var isMobile = window.innerWidth <= 768;
        if (color === 'carbon') {
          bgEl.style.backgroundImage = isMobile
            ? "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Mobile.jpg?v=1782474367')"
            : "url('https://cdn.shopify.com/s/files/1/0348/7053/files/choosemuse_home_product_CARBON_Web.jpg?v=1782474356')";
        } else {
          var desktop = bgEl.getAttribute('data-bg-desktop');
          var mobile = bgEl.getAttribute('data-bg-mobile');
          if (isMobile && mobile) {
            bgEl.style.backgroundImage = "url('" + mobile + "')";
          } else if (desktop) {
            bgEl.style.backgroundImage = "url('" + desktop + "')";
          }
        }
      });
    }, 200);
  });


});

} catch (error) { console.warn("Muse source module home-1", error); }
try {

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeProductsSticky);
  } else {
    initHomeProductsSticky();
  }

  function initHomeProductsSticky() {
    var section = document.querySelector('.home-products-section');
    var sticky  = document.getElementById('home-products-sticky');
    var testimonialsSection = document.querySelector('.scroll-video-frame') || document.getElementById('scroll-video-frame');
    var cardsSection = document.querySelector('.home-products-cards');

    if (!section || !sticky || !testimonialsSection) return;

    /* ── Scroll state: show only once the testimonials section is reached ── */
    var hasReachedTestimonials = false;
    var isCardsIntersecting = false;

    var testimonialsObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var rect = entry.boundingClientRect;
        hasReachedTestimonials = entry.isIntersecting || rect.top < 0;
        updateVisibility();
      });
    }, { root: null, rootMargin: '0px', threshold: 0 });

    testimonialsObserver.observe(testimonialsSection);

    if (cardsSection) {
      var cardsObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var rect = entry.boundingClientRect;
          isCardsIntersecting = entry.isIntersecting || rect.top < 0;
          updateVisibility();
        });
      }, { root: null, rootMargin: '0px', threshold: 0 });
      cardsObserver.observe(cardsSection);
    }

    function updateVisibility() {
      var shouldShow = hasReachedTestimonials && !isCardsIntersecting;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    /* ── Content sync (variant-aware) ── */
    function updateStickyContent() {
      var activeView = section.querySelector('.home-products-section__view.is-active');
      if (!activeView) return;

      var activeProduct   = activeView.getAttribute('data-product-view'); // "1" or "2"
      var selectedVariant = activeView.getAttribute('data-showcase-selected') || 'bundle';
      var isBundle        = selectedVariant === 'bundle';

      var suffix = isBundle ? '' : '-solo';

      var price      = sticky.getAttribute('data-product-' + activeProduct + suffix + '-price');
      var currency   = sticky.getAttribute('data-product-' + activeProduct + '-currency');
      var name       = sticky.getAttribute('data-product-' + activeProduct + suffix + '-name');
      var url        = sticky.getAttribute('data-product-' + activeProduct + suffix + '-url');
      var variantId  = sticky.getAttribute('data-product-' + activeProduct + suffix + '-variant-id');
      var premium    = sticky.getAttribute('data-product-' + activeProduct + '-premium');

      var priceEl     = sticky.querySelector('[data-sticky-price]');
      var currencyEl  = sticky.querySelector('[data-sticky-currency]');
      var nameEl      = sticky.querySelector('[data-sticky-name]');
      var atcBtn      = sticky.querySelector('[data-sticky-atc]');
      var learnBtn    = sticky.querySelector('[data-sticky-learn]');
      var shippingEl  = sticky.querySelector('[data-sticky-shipping]');

      if (priceEl)     priceEl.textContent     = price     ? 'Muse reference: $' + price : '';
      if (currencyEl)  currencyEl.textContent  = currency  || 'USD';
      if (nameEl)      nameEl.textContent      = name      || '';

      // Shipping / premium note
      if (shippingEl) {
        shippingEl.textContent = premium ? 'Manufacturer terms: ' + premium : '';
        shippingEl.style.display = premium ? '' : 'none';
      }

      // Sticky bundle/solo note
      sticky.querySelectorAll('.sticky-bundle-note').forEach(function (el) {
        var isMatch = el.getAttribute('data-product') === activeProduct
                   && el.getAttribute('data-showcase-variant') === selectedVariant;
        el.classList.toggle('is-visible', isMatch);
      });

      // ATC button
      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', variantId || '');
        atcBtn.setAttribute('data-product_id', variantId || '');
        atcBtn.textContent = 'View Invincible Human program';
      }

      // Learn more
      if (learnBtn && url) {
        learnBtn.href = activeProduct === '2' ? '/pages/muse-2' : '/pages/muse-athena';
      }
    }

    /* ── Listen for view switches AND variant toggles ── */
    var viewsContainer = section.querySelector('[data-home-products]');
    if (viewsContainer) {
      viewsContainer.addEventListener('click', function(e) {
        var switcher = e.target.closest('[data-switch-to]');
        if (switcher) {
          setTimeout(updateStickyContent, 60);
          setTimeout(updateVisibility, 60);
        }
      });
    }

    /* ── Expose globally for variant toggle calls ── */
    window.updateHomeSticky = function() {
      updateStickyContent();
      var activeView = section.querySelector('.home-products-section__view.is-active');
      if (activeView) {
        window.syncAllIndicatorsAndTabs(activeView.getAttribute('data-showcase-selected') || 'bundle');
      }
    };

    /* ── Init ── */
    updateStickyContent();
    window.syncAllIndicatorsAndTabs('bundle');
    window.addEventListener('load', function() {
      updateStickyContent();
      window.syncAllIndicatorsAndTabs('bundle');
    });

    /* ── Mobile Explore: switch product + scroll ── */
    var exploreBtn = sticky.querySelector('.sticky-learn-btn.hidden-lg');
    if (exploreBtn) {
      exploreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var activeView = section.querySelector('.home-products-section__view.is-active');
        if (!activeView) return;
        var activeProduct = activeView.getAttribute('data-product-view');
        var target = activeProduct === '1' ? '2' : '1';
        var switcher = section.querySelector('.home-products-section__switcher[data-switch-to="' + target + '"]');
        if (switcher) {
          switcher.click();
          var inner = section.querySelector('.home-products-section__inner');
          if (inner) {
            setTimeout(function() {
              inner.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
      });
    }

  }
})();

} catch (error) { console.warn("Muse source module home-2", error); }
try {

(function() {
  'use strict';

  var AUTO_SCROLL_ENABLED = true;   // ← Toggle autoscroll on/off
  var AUTO_SCROLL_DELAY   = 4000;   // ← Delay between slides (ms)
  var MOBILE_BREAKPOINT   = 768;    // ← Mobile width threshold

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initSpecCarousel(list) {
    var items = list.querySelectorAll('.home-products-section__spec-image-item');
    if (items.length <= 1) return;

    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'spec-dots';

    for (var i = 0; i < items.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'spec-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-index', i);
      dotsContainer.appendChild(dot);
    }

    list.parentNode.insertBefore(dotsContainer, list.nextSibling);

    var currentIndex = 0;
    var autoScrollTimer = null;
    var isPaused = false;

    function goToSlide(index) {
      var itemWidth = items[0].offsetWidth;
      list.scrollTo({ left: index * itemWidth, behavior: 'smooth' });
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % items.length;
      goToSlide(currentIndex);
    }

    function updateDots(activeIndex) {
      activeIndex = Math.max(0, Math.min(activeIndex, items.length - 1));
      currentIndex = activeIndex;
      var dots = dotsContainer.querySelectorAll('.spec-dot');
      dots.forEach(function(d, idx) {
        d.classList.toggle('is-active', idx === activeIndex);
      });
    }

    function startAutoScroll() {
      if (!AUTO_SCROLL_ENABLED || !isMobile()) return;
      stopAutoScroll();
      autoScrollTimer = setInterval(function() {
        if (!isPaused) {
          nextSlide();
        }
      }, AUTO_SCROLL_DELAY);
    }

    function stopAutoScroll() {
      if (autoScrollTimer) {
        clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    function resetAutoScroll() {
      stopAutoScroll();
      startAutoScroll();
    }

    // ── Scroll sync → update dots ──
    var ticking = false;
    list.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollLeft = list.scrollLeft;
          var itemWidth = items[0].offsetWidth;
          var activeIndex = Math.round(scrollLeft / itemWidth);
          updateDots(activeIndex);
          ticking = false;
        });
        ticking = true;
      }
    });

    // ── Dot click ──
    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.spec-dot');
      if (!dot) return;
      var index = parseInt(dot.getAttribute('data-index'), 10);
      currentIndex = index;
      goToSlide(index);
      resetAutoScroll();
    });

    // ── Pause on touch / interaction (mobile only) ──
    list.addEventListener('touchstart', function() {
      isPaused = true;
    }, { passive: true });

    list.addEventListener('touchend', function() {
      isPaused = false;
      resetAutoScroll();
    });

    // ── Pause when tab is hidden ──
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoScroll();
      } else if (isMobile()) {
        startAutoScroll();
      }
    });

    // ── Handle resize (start/stop based on mobile breakpoint) ──
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (isMobile()) {
          startAutoScroll();
        } else {
          stopAutoScroll();
        }
      }, 250);
    });

    // ── Start if mobile ──
    if (isMobile()) {
      startAutoScroll();
    }
  }

  function init() {
    document.querySelectorAll('.home-products-section__spec-images').forEach(initSpecCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

} catch (error) { console.warn("Muse source module home-3", error); }
try {

(function() {
  'use strict';

  var sectionId = 'template--26315190534511__sharper_focus_AkDq8T';
  var section = document.getElementById('feature-section-' + sectionId);
  if (!section) return;

  var featureMobileTrack = document.getElementById('featureMobileTrack-' + sectionId);
  var featureMobileSlides = Array.from(section.querySelectorAll('.feature-mobile-slide'));
  var featureMobileDots = Array.from(section.querySelectorAll('.feature-mobile-dot'));

  var clamp = function(value, min, max) { return Math.min(max, Math.max(min, value)); };
  var mobileMediaQuery = window.matchMedia('(max-width: 700px)');
  var featureMobileStartProgress = 0.18;
  var featureMobileEndProgress = 0.82;
  var featureSnapDuration = 1500;
  var featureSnapTimer = 0;
  var featureSnapAnimationFrame = 0;
  var featureIsSnapping = false;
  var featureSnapState = 0;
  var lastFeatureScrollY = window.scrollY;

  // ===== DESKTOP: Scroll-driven active state =====
  function updateFeatureScroll() {
    var scrollStart = section.offsetTop;
    var scrollEnd = scrollStart + section.offsetHeight - window.innerHeight;
    var scrollRange = Math.max(1, scrollEnd - scrollStart);
    var progress = clamp((window.scrollY - scrollStart) / scrollRange, 0, 1);
    var scrollDirection = window.scrollY > lastFeatureScrollY ? 1 : window.scrollY < lastFeatureScrollY ? -1 : 0;
    var activeFeature = progress < 0.5 ? 'focus' : 'strength';

    if (section.dataset.activeFeature !== activeFeature) {
      section.dataset.activeFeature = activeFeature;
    }

    updateMobileFeatureScroll(progress);
    scheduleMobileFeatureSnap(progress, scrollStart, scrollRange, scrollDirection);
    lastFeatureScrollY = window.scrollY;
  }

  // ===== MOBILE: Scroll-linked carousel =====
  function updateMobileFeatureScroll(progress) {
    if (!mobileMediaQuery.matches || !featureMobileTrack) return;

    var easedProgress = clamp(
      (progress - featureMobileStartProgress) / (featureMobileEndProgress - featureMobileStartProgress),
      0,
      1
    );
    var smoothProgress = easedProgress * easedProgress * (3 - 2 * easedProgress);
    var maxScroll = Math.max(0, featureMobileTrack.scrollWidth - featureMobileTrack.clientWidth);

    featureMobileTrack.scrollLeft = maxScroll * smoothProgress;
    if (progress <= 0.02) featureSnapState = 0;
    if (progress >= 0.98) featureSnapState = 1;
    updateMobileFeatureDots();
  }

  function scheduleMobileFeatureSnap(progress, scrollStart, scrollRange, scrollDirection) {
    if (!mobileMediaQuery.matches || featureIsSnapping) return;
    if (progress <= 0 || progress >= 1) return;
    if (scrollDirection === 0) return;

    window.clearTimeout(featureSnapTimer);
    featureSnapTimer = window.setTimeout(function() {
      var targetState = scrollDirection > 0 ? 1 : 0;
      if (targetState === featureSnapState) return;

      var targetTop = scrollStart + scrollRange * targetState;
      animateMobileFeatureSnap(targetTop, targetState);
    }, 110);
  }

  function animateMobileFeatureSnap(targetTop, targetState) {
    var startTop = window.scrollY;
    var distance = targetTop - startTop;
    var startTime = performance.now();

    window.cancelAnimationFrame(featureSnapAnimationFrame);
    featureIsSnapping = true;
    featureSnapState = targetState;

    function step(now) {
      var progress = clamp((now - startTime) / featureSnapDuration, 0, 1);
      var easedProgress = 0.5 - Math.cos(progress * Math.PI) / 2;

      window.scrollTo(0, startTop + distance * easedProgress);

      if (progress < 1) {
        featureSnapAnimationFrame = window.requestAnimationFrame(step);
        return;
      }

      window.scrollTo(0, targetTop);
      featureIsSnapping = false;
      lastFeatureScrollY = window.scrollY;
      updateFeatureScroll();
    }

    featureSnapAnimationFrame = window.requestAnimationFrame(step);
  }

  function updateMobileFeatureDots() {
    if (!featureMobileTrack || !featureMobileDots.length) return;
    var trackPaddingLeft = parseFloat(window.getComputedStyle(featureMobileTrack).paddingLeft) || 0;

    var activeIndex = featureMobileSlides.reduce(function(closestIndex, slide, index) {
      var closestLeft = featureMobileSlides[closestIndex].offsetLeft - featureMobileTrack.offsetLeft - trackPaddingLeft;
      var slideLeft = slide.offsetLeft - featureMobileTrack.offsetLeft - trackPaddingLeft;
      var closestDistance = Math.abs(closestLeft - featureMobileTrack.scrollLeft);
      var distance = Math.abs(slideLeft - featureMobileTrack.scrollLeft);
      return distance < closestDistance ? index : closestIndex;
    }, 0);

    featureMobileDots.forEach(function(dot, index) {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  // Dot click handlers
  featureMobileDots.forEach(function(dot, index) {
    dot.addEventListener('click', function() {
      var trackPaddingLeft = parseFloat(window.getComputedStyle(featureMobileTrack).paddingLeft) || 0;
      var targetLeft = (featureMobileSlides[index].offsetLeft - featureMobileTrack.offsetLeft - trackPaddingLeft);
      featureMobileTrack.scrollTo(targetLeft, 0);
      updateMobileFeatureDots();
    });
  });

  // Track scroll for dots
  if (featureMobileTrack) {
    featureMobileTrack.addEventListener('scroll', function() {
      window.requestAnimationFrame(updateMobileFeatureDots);
    }, { passive: true });
  }

  // ===== DESKTOP: Hover on cards switches active feature =====
  var featureCards = Array.from(section.querySelectorAll('.feature-card'));

  featureCards.forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      var blockType = card.dataset.blockType;
      if (blockType) section.dataset.activeFeature = blockType;
    });

    card.addEventListener('click', function() {
      var blockType = card.dataset.blockType;
      if (blockType) section.dataset.activeFeature = blockType;
    });
    
  });
  // Init
  updateFeatureScroll();
  updateMobileFeatureDots();

  window.addEventListener('scroll', updateFeatureScroll, { passive: true });
  window.addEventListener('resize', function() {
    updateFeatureScroll();
    updateMobileFeatureDots();
  });
  if (mobileMediaQuery.addEventListener) {
    mobileMediaQuery.addEventListener('change', function() {
      updateFeatureScroll();
      updateMobileFeatureDots();
    });
  }
})();

} catch (error) { console.warn("Muse source module home-4", error); }
try {

(function() {
  'use strict';

  var sectionId = 'template--26315190534511__scroll_video_JaLMeG';
  var section = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (!section) return;

  var video = document.getElementById('scrollVideo-' + sectionId);
  var graphOverlay = document.getElementById('graphOverlay-' + sectionId);
  var graphPath = document.getElementById('graphPath-' + sectionId);
  var graphPreviewPath = document.getElementById('graphPreviewPath-' + sectionId);
  var graphTrail = document.getElementById('graphTrail-' + sectionId);
  var graphTrailGradient = document.getElementById('scrollGraphTrailGradient-' + sectionId);
  var graphDot = document.getElementById('graphDot-' + sectionId);
  var sleepTools = Array.from(section.querySelectorAll('.scroll-sleep-tool'));
  var phaseIconImages = Array.from(section.querySelectorAll('.scroll-phase-icon-img'));

  var targetTime = 0;
  var graphLength = 0;
  var activePhaseIconIndex = 0;
  var activePhaseIconLayer = 0;
  var videoScrubbing = false;
  //var videoStepSeconds = 4;

  var clamp = function(value, min, max) { return Math.min(max, Math.max(min, value)); };

  var colorStops = [
    { progress: 0, color: [242, 153, 74] },
    { progress: 0.5, color: [194, 37, 150] },
    { progress: 1, color: [242, 203, 74] }
  ];

  var toolStops = [];
  sleepTools.forEach(function(tool, index) {
    var total = sleepTools.length;
    var progress = total > 1 ? index / (total - 1) : 0;
    var rgb = tool.style.getPropertyValue('--tool-active-rgb').split(',').map(function(n) { return parseInt(n.trim(), 10); });
    var darkText = parseFloat(tool.style.getPropertyValue('--tool-dark-text')) || 0;
    toolStops.push({ progress: progress, color: rgb.length === 3 ? rgb : [255, 255, 255], darkText: darkText });
  });

  var phaseIcons = [];
  phaseIconImages.forEach(function(img) {
    var src = img.getAttribute('data-phase-src');
    if (src) phaseIcons.push(src);
  });
  if (phaseIcons.length < 3) {
    phaseIconImages.forEach(function(img) {
      if (!img.getAttribute('data-phase-src') && img.src) {
        phaseIcons[parseInt(img.getAttribute('data-phase'), 10)] = img.src;
      }
    });
  }

  var mobileMediaQuery = window.matchMedia('(max-width: 768px)');

  function normalizeUrl(url) {
    if (!url) return '';
    var link = document.createElement('a');
    link.href = url;
    return link.href;
  }

  function syncVideoSource() {
    var nextSrc = mobileMediaQuery.matches && video.dataset.mobileSrc ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    var currentSrc = video.currentSrc || video.getAttribute('src');
    if (!nextSrc || currentSrc === nextSrc) return;
    if (normalizeUrl(currentSrc) === normalizeUrl(nextSrc)) return;
    videoScrubbing = false;
    targetTime = 0;
    video.pause();
    video.src = nextSrc;
    video.load();
  }

  

function updateTargetTime() {
  var scrollStart = section.offsetTop;
  var scrollEnd = scrollStart + section.offsetHeight - window.innerHeight;
  var scrollRange = Math.max(1, scrollEnd - scrollStart);
  var progress = clamp((window.scrollY - scrollStart) / scrollRange, 0, 1);

  updateGraph(progress);

  if (!video.duration || !isFinite(video.duration)) return;

  targetTime = clamp(progress * video.duration, 0, Math.max(0, video.duration - 0.05));

  if (!videoScrubbing) {
    videoScrubbing = true;
    requestAnimationFrame(scrubVideo);
  }
}
  function getSegmentInfo(progress) {
    var segmentCount = Math.max(1, sleepTools.length || 3);
    var safeProgress = clamp(progress, 0, 1);
    var segmentIndex = Math.min(segmentCount - 1, Math.floor(safeProgress * segmentCount));
    var segmentStartProgress = segmentIndex / segmentCount;
    var segmentProgress = clamp((safeProgress - segmentStartProgress) * segmentCount, 0, 1);

    return {
      count: segmentCount,
      index: segmentIndex,
      progress: segmentProgress
    };
  }

  
  

  var seekPending = false;

  function scrubVideo() {
    video.playbackRate = 1;
    var diff = targetTime - video.currentTime;

    if (Math.abs(diff) <= 0.025) {
      if (!seekPending) {
        video.currentTime = targetTime;
      }
      videoScrubbing = false;
      return;
    }

    if (!seekPending) {
      seekPending = true;
      video.currentTime += diff * 0.22;
    }

    requestAnimationFrame(scrubVideo);
  }

  video.addEventListener('seeked', function() {
      seekPending = false;
    });
  function initGraph() {
    if (!graphPath) return;
    graphLength = graphPath.getTotalLength();
    graphPath.style.strokeDasharray = graphLength;
    graphPath.style.strokeDashoffset = graphLength;
    graphTrail.style.strokeDasharray = graphLength;
    graphTrail.style.strokeDashoffset = graphLength;
    graphPreviewPath.style.strokeDasharray = 'none';
    graphPreviewPath.style.strokeDashoffset = 0;
    updateGraph(0);
  }

  function updateGraph(progress) {
    if (!graphLength) return;
    var safeProgress = clamp(progress, 0, 1);
    var easedProgress = safeProgress * safeProgress * (3 - 2 * safeProgress);
    var dotLength = clamp(easedProgress * graphLength, 0, graphLength - 0.01);
    var point = graphPath.getPointAtLength(dotLength);
    var slideX = 180 - easedProgress * 350;
    var activeColor = getGraphColor(safeProgress);

    graphDot.setAttribute('cx', point.x);
    graphDot.setAttribute('cy', point.y);
    graphDot.setAttribute('fill', activeColor);

    document.body.style.setProperty('--scroll-color-rgb', activeColor.match(/\d+/g).join(', '));
    graphOverlay.style.setProperty('--graph-x', slideX + 'px');
    graphPath.style.strokeDashoffset = graphLength - dotLength;
    updateTrail(dotLength, point, activeColor);
    updateSleepTools(safeProgress);
    updatePhaseIcon(safeProgress);
  }

  function getGraphColor(progress) {
    var nextStopIndex = colorStops.findIndex(function(stop) { return progress <= stop.progress; });
    var endStop = colorStops[Math.max(1, nextStopIndex)];
    var startStop = colorStops[Math.max(0, colorStops.indexOf(endStop) - 1)];
    var segmentProgress = clamp((progress - startStop.progress) / (endStop.progress - startStop.progress), 0, 1);
    var easedColorProgress = segmentProgress * segmentProgress * (3 - 2 * segmentProgress);
    var red = Math.round(startStop.color[0] + (endStop.color[0] - startStop.color[0]) * easedColorProgress);
    var green = Math.round(startStop.color[1] + (endStop.color[1] - startStop.color[1]) * easedColorProgress);
    var blue = Math.round(startStop.color[2] + (endStop.color[2] - startStop.color[2]) * easedColorProgress);
    return 'rgb(' + red + ', ' + green + ', ' + blue + ')';
  }

  function updateTrail(dotLength, point, color) {
    var trailLength = 360;
    var trailStart = clamp(dotLength - trailLength, 0, graphLength);
    var visibleTrailLength = dotLength - trailStart;
    graphTrail.style.strokeDasharray = visibleTrailLength + ' ' + graphLength;
    graphTrail.style.strokeDashoffset = -(trailStart);
    graphTrail.setAttribute('opacity', dotLength > 2 ? '1' : '0');
    graphTrailGradient.setAttribute('x1', String(Math.max(0, point.x - 120)));
    graphTrailGradient.setAttribute('y1', String(point.y));
    graphTrailGradient.setAttribute('x2', String(point.x));
    graphTrailGradient.setAttribute('y2', String(point.y));
    var stops = graphTrailGradient.querySelectorAll('stop');
    stops.forEach(function(stop) {
      stop.setAttribute('stop-color', color);
    });
  }

  function updateSleepTools(progress) {
    var activeSegment = getSegmentInfo(progress);

    sleepTools.forEach(function(tool, index) {
      var stop = toolStops[index];
      if (!stop) return;
      var activity = index === activeSegment.index ? 1 : 0;
      var easedActivity = activity * activity * (3 - 2 * activity);
      tool.style.setProperty('--tool-active', easedActivity.toFixed(3));
      tool.style.setProperty('--tool-active-rgb', stop.color.join(', '));
      tool.style.setProperty('--tool-active-red', stop.color[0]);
      tool.style.setProperty('--tool-active-green', stop.color[1]);
      tool.style.setProperty('--tool-active-blue', stop.color[2]);
      tool.style.setProperty('--tool-dark-text', (stop.darkText * easedActivity).toFixed(3));
    });
  }

  function updatePhaseIcon(progress) {
    var nextIndex = progress < 1 / 3 ? 0 : progress < 2 / 3 ? 1 : 2;
    if (nextIndex === activePhaseIconIndex) return;
    var outgoing = phaseIconImages[activePhaseIconLayer];
    activePhaseIconLayer = 1 - activePhaseIconLayer;
    var incoming = phaseIconImages[activePhaseIconLayer];
    outgoing.classList.remove('is-active');
    outgoing.classList.add('is-exiting');
    incoming.classList.remove('is-exiting', 'is-active');
    if (phaseIcons[nextIndex]) {
      incoming.src = phaseIcons[nextIndex];
    }
    incoming.offsetHeight;
    incoming.classList.add('is-active');
    window.setTimeout(function() {
      outgoing.classList.remove('is-exiting');
    }, 280);
    activePhaseIconIndex = nextIndex;
  }

  syncVideoSource();
  initGraph();
  updateTargetTime();


  video.addEventListener('loadedmetadata', updateTargetTime);
  window.addEventListener('scroll', updateTargetTime, { passive: true });
  window.addEventListener('resize', function() {
    syncVideoSource();
    updateTargetTime();
  });
  window.addEventListener('orientationchange', function() {
    window.setTimeout(function() {
      syncVideoSource();
      updateTargetTime();
    }, 250);
  });
  if (mobileMediaQuery.addEventListener) {
    mobileMediaQuery.addEventListener('change', function() {
      syncVideoSource();
      updateTargetTime();
    });
  }
  sleepTools.forEach(function(tool, index) {
  tool.addEventListener('click', function() {
    var segmentCount = Math.max(1, sleepTools.length || 3);
    var scrollStart = section.offsetTop;
    var scrollEnd = scrollStart + section.offsetHeight - window.innerHeight;
    var scrollRange = Math.max(1, scrollEnd - scrollStart);

    // target the center of this segment so it lands clearly "active"
    var segmentCenterProgress = (index + 0.5) / segmentCount;
    var targetScrollY = scrollStart + scrollRange * segmentCenterProgress;

    window.scrollTo({
      top: targetScrollY,
      behavior: 'smooth'
    });
  });
});
})();

} catch (error) { console.warn("Muse source module home-5", error); }
try {

(function() {
  var sectionId = 'template--26315190534511__shop_testimonial_jiRnVy';
  var section = document.querySelector('[data-shop-testimonial="' + sectionId + '"]');
  if (!section) section = document.querySelector('.testimonials-section');

  var track = section.querySelector('.testimonials__track');
  var bullets = section.querySelectorAll('.testimonials__bullet');

  if (!track || !bullets.length) return;

  function setActive(index) {
    bullets.forEach(function(bullet, i) {
      bullet.classList.toggle('is-active', i === index);
    });
  }

  function goToSlide(index) {
    if (index < 0 || index >= bullets.length) return;

    var card = section.querySelectorAll('.testimonial-card')[index];
    if (!card) return;

    /* Center the card within the track viewport */
    var targetLeft = card.offsetLeft - track.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    track.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });

    setActive(index);
  }

  bullets.forEach(function(bullet) {
    bullet.addEventListener('click', function() {
      goToSlide(parseInt(this.getAttribute('data-index'), 10));
    });
  });

  var scrollTimer;

  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(function() {
      var cards = section.querySelectorAll('.testimonial-card');
      var scrollCenter = track.scrollLeft + track.clientWidth / 2;

      /* Find the card whose center is closest to the viewport center */
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function(card, i) {
        var cardCenter = card.offsetLeft - track.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - scrollCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = i;
        }
      });

      setActive(nearestIndex);
    }, 80);
  });
})();

} catch (error) { console.warn("Muse source module home-6", error); }
try {

 /* ============================================================
   HOME SCIENCE SECTION — Extracted JavaScript
   ============================================================ */

(function () {
  "use strict";

  /* ---------- DOM References ---------- */
  const scienceDonutValue   = document.getElementById("scienceDonutValue");
  const scienceDonutLabel   = document.getElementById("scienceDonutLabel");
  const scienceDonutSteps   = Array.from(document.querySelectorAll(".science-donut-step"));
  const scienceMetricCopy   = document.querySelector(".science-metric-copy");
  const scienceMetricList   = document.querySelector(".science-metric-list");
  const scienceMetricItems  = Array.from(document.querySelectorAll(".science-metric-item"));

  /* ---------- Config ---------- */
  const config = window.scienceSectionConfig || {};
  const scienceMetricValues = config.metricValues
    ? config.metricValues.map(Number)
    : [77, 72, 20, 78, 72];
  const scienceMetricDuration = config.stepDuration || 4200;
  const scienceMetricRealCount = scienceMetricValues.length;

  let scienceMetricIndex = 0;
  let scienceIntervalId = null;
  let sciencePaused = false;
  const scienceReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const mobileMediaQuery = window.matchMedia("(max-width: 700px)");

  /* ---------- Helpers ---------- */
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  /* ---------- Donut Update ---------- */
  function updateScienceDonut(index) {
    if (!scienceDonutValue || !scienceDonutLabel) return;

    const value  = scienceMetricValues[index % scienceMetricRealCount];
    const radius = Number(scienceDonutValue.getAttribute("r"));
    const circumference = 2 * Math.PI * radius;

    scienceDonutValue.style.strokeDasharray   = `${circumference}`;
    scienceDonutValue.style.strokeDashoffset  = `${circumference * (1 - value / 100)}`;
    scienceDonutLabel.textContent = `${value}%`;

    scienceDonutSteps.forEach((step, stepIndex) => {
      step.classList.toggle("is-complete", stepIndex < index % scienceMetricRealCount);
      step.classList.toggle("is-active", stepIndex === index % scienceMetricRealCount);
      step.style.setProperty("--science-step-duration", `${scienceMetricDuration}ms`);
    });

    updateScienceMetricText(index % scienceMetricRealCount);
  }

  /* ---------- Metric Text Scroll ---------- */
  function updateScienceMetricText(index) {
    if (!scienceMetricCopy || !scienceMetricList || !scienceMetricItems.length) return;

    const activeItem = scienceMetricItems[index];
    if (!activeItem) return;

    const isMobile = mobileMediaQuery.matches;
    const copyCenter = (isMobile ? scienceMetricCopy.clientWidth : scienceMetricCopy.clientHeight) / 2;
    const itemCenter = isMobile
      ? activeItem.offsetLeft + activeItem.offsetWidth / 2
      : activeItem.offsetTop + activeItem.offsetHeight / 2;
    const targetOffset = copyCenter - itemCenter;

    scienceMetricList.style.setProperty("--science-copy-y", isMobile ? "0px" : `${targetOffset}px`);
    scienceMetricList.style.setProperty("--science-copy-x", isMobile ? `${targetOffset}px` : "0px");

    scienceMetricItems.forEach((item, itemIndex) => {
      item.classList.toggle("is-active", itemIndex === index);
    });
  }

  /* ---------- Loop Reset (seamless infinite scroll) ---------- */
  function syncScienceMetricLoopPosition() {
    if (!scienceMetricList || scienceMetricIndex !== scienceMetricRealCount) return;

    scienceMetricList.style.transition = "none";
    scienceMetricIndex = 0;
    updateScienceDonut(scienceMetricIndex);
    updateScienceMetricText(scienceMetricIndex);
    scienceMetricList.offsetHeight; // force reflow
    scienceMetricList.style.transition = "";
  }

  /* ---------- Init & Auto-cycle ---------- */
  function initScienceSection() {
    updateScienceDonut(scienceMetricIndex);
    window.requestAnimationFrame(() => updateScienceMetricText(scienceMetricIndex));
    startScienceCycle();
  }

  function startScienceCycle() {
    if (scienceIntervalId || scienceReduceMotion.matches) return;
    scienceIntervalId = window.setInterval(() => {
      const nextMetricIndex = scienceMetricIndex + 1;
      scienceMetricIndex = nextMetricIndex;
      updateScienceDonut(nextMetricIndex % scienceMetricRealCount);
      updateScienceMetricText(nextMetricIndex % scienceMetricRealCount);

      if (nextMetricIndex === scienceMetricRealCount) {
        window.setTimeout(syncScienceMetricLoopPosition, 1700);
      }
    }, scienceMetricDuration);
  }

  /* ---------- Pause Control (WCAG 2.2.2) ---------- */
  function setSciencePaused(paused) {
    sciencePaused = paused;
    var root = document.querySelector(".science-section");
    if (root) root.classList.toggle("science-section--paused", paused);
    var btn = document.querySelector("[data-science-pause]");
    if (btn) {
      btn.setAttribute("aria-pressed", paused ? "true" : "false");
      btn.setAttribute("aria-label", paused ? "Play science animation" : "Pause science animation");
      btn.classList.toggle("is-paused", paused);
      btn.setAttribute("data-button-state", paused ? "paused" : "play");
    }
    if (paused) {
      if (scienceIntervalId) { window.clearInterval(scienceIntervalId); scienceIntervalId = null; }
    } else {
      startScienceCycle();
    }
  }

  (function initSciencePause() {
    var btn = document.querySelector("[data-science-pause]");
    if (btn) {
      btn.addEventListener("click", function () { setSciencePaused(!sciencePaused); });
    }
    if (scienceReduceMotion.matches) setSciencePaused(true);
  })();

  /* ---------- Resize / Orientation ---------- */
  function handleResize() {
    updateScienceMetricText(scienceMetricIndex % scienceMetricRealCount);
  }

  window.addEventListener("resize", handleResize);
  window.addEventListener("orientationchange", () => {
    window.setTimeout(handleResize, 250);
  });
  mobileMediaQuery.addEventListener?.("change", handleResize);

  /* ---------- Boot ---------- */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScienceSection);
  } else {
    initScienceSection();
  }
})();

} catch (error) { console.warn("Muse source module home-7", error); }
try {

  /* ============================================================
     HOME PREMIUM UNLOCK — Inline JavaScript
     ============================================================ */
  (function () {
    "use strict";

    const premiumVideos = Array.from(document.querySelectorAll(".premium-app-video"));
    const premiumHeroVideo = document.querySelector(".premium-desktop-video");
    const premiumMediaVideos = Array.from(document.querySelectorAll(".premium-desktop-video, .premium-mobile-enso-video"));
    const mobileMediaQuery = window.matchMedia("(max-width: 700px)");

    /* ---------- Premium App Videos (Intersection Observer) ---------- */
    function initPremiumVideos() {
      if (!premiumVideos.length) return;

      const premiumSection = document.querySelector(".premium-section");
      let premiumVideoStartTimer = 0;
      let premiumVideoSequenceStarted = false;
      const premiumVideoStartDelay = 500;
      const premiumVideoStagger = 250;

      function playPremiumVideo(index) {
        const premiumVideo = premiumVideos[index];
        if (!premiumVideo) return;
        premiumVideo.currentTime = 0;
        premiumVideo.play().catch(function () {});
      }

      premiumVideos.forEach(function (video) {
        video.loop = false;
      });

      function startPremiumVideoSequence() {
        if (premiumVideoSequenceStarted) return;
        premiumVideoSequenceStarted = true;
        premiumVideos.forEach(function (premiumVideo, index) {
          window.setTimeout(function () {
            playPremiumVideo(index);
          }, premiumVideoStagger * index);
        });
      }

      if (!("IntersectionObserver" in window)) {
        window.setTimeout(startPremiumVideoSequence, premiumVideoStartDelay);
        return;
      }

      const premiumVideoObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          window.clearTimeout(premiumVideoStartTimer);
          premiumVideoStartTimer = window.setTimeout(startPremiumVideoSequence, premiumVideoStartDelay);
          return;
        }
        window.clearTimeout(premiumVideoStartTimer);
      }, { threshold: 0.35 });

      premiumVideoObserver.observe(premiumSection);
    }

    /* ---------- Premium Hero + Media Videos (Responsive Source) ---------- */
    function initPremiumMediaVideos() {
      if (!premiumMediaVideos.length) return;

      function syncPremiumHeroVideoSource() {
        if (!premiumHeroVideo) return;
        var nextSrc = mobileMediaQuery.matches
          ? premiumHeroVideo.dataset.mobileSrc
          : premiumHeroVideo.dataset.desktopSrc;
        if (!nextSrc || premiumHeroVideo.getAttribute("src") === nextSrc) return;
        premiumHeroVideo.pause();
        premiumHeroVideo.src = nextSrc;
        premiumHeroVideo.load();
      }

      function playVisiblePremiumMediaVideos() {
        syncPremiumHeroVideoSource();
        premiumMediaVideos.forEach(function (premiumMediaVideo) {
          if (premiumMediaVideo.dataset.userPaused === 'true') return;
          var isVisible = window.getComputedStyle(premiumMediaVideo).display !== "none";
          if (!isVisible) {
            premiumMediaVideo.pause();
            return;
          }
          premiumMediaVideo.play().catch(function () {});
        });
      }

      playVisiblePremiumMediaVideos();

      if ("IntersectionObserver" in window) {
        var premiumMediaObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            playVisiblePremiumMediaVideos();
          });
        }, { threshold: 0.25 });

        premiumMediaVideos.forEach(function (premiumMediaVideo) {
          premiumMediaObserver.observe(premiumMediaVideo);
        });
      }

      if (mobileMediaQuery.addEventListener) {
        mobileMediaQuery.addEventListener("change", playVisiblePremiumMediaVideos);
      }

    /* ---------- Pause Control (WCAG 2.2.2) ---------- */
    var premiumReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var premiumPaused = false;
    function setPremiumPaused(paused) {
      premiumPaused = paused;
      var root = document.querySelector(".premium-section");
      if (root) root.classList.toggle("premium-section--paused", paused);
      var btn = document.querySelector("[data-premium-pause]");
      if (btn) {
        btn.setAttribute("aria-pressed", paused ? "true" : "false");
        btn.setAttribute("aria-label", paused ? "Play animations" : "Pause animations");
        btn.classList.toggle("is-paused", paused);
        btn.setAttribute("data-button-state", paused ? "paused" : "play");
      }
      if (paused) {
        premiumMediaVideos.forEach(function (v) { v.pause(); v.dataset.userPaused = "true"; });
      } else {
        premiumMediaVideos.forEach(function (v) { v.dataset.userPaused = "false"; });
        playVisiblePremiumMediaVideos();
      }
    }
    var premiumPauseBtn = document.querySelector("[data-premium-pause]");
    if (premiumPauseBtn) {
      premiumPauseBtn.addEventListener("click", function () { setPremiumPaused(!premiumPaused); });
    }
    if (premiumReduceMotion.matches) setPremiumPaused(true);
    }

    /* ---------- Boot ---------- */
    function init() {
      initPremiumVideos();
      initPremiumMediaVideos();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }

  })();

} catch (error) { console.warn("Muse source module home-8", error); }
},
"how-it-works":function(document,window){
try {

(function () {
  var section = document.getElementById('premium-hero-template--26315188863343__premium_hero_4nBCFN');
  if (!section) return;

  var videos = section.querySelectorAll('video.premium-hero__video');
  var button = section.querySelector('.patrol-video__button');

  if (!videos.length || !button) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(function() {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  button.addEventListener('click', function () {
    var anyPlaying = Array.prototype.some.call(videos, function(v) { return !v.paused; });
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var video = entry.target;
      if (video.dataset.userPaused === 'true') return;
      if (entry.isIntersecting) {
        video.play().catch(function() {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(function(video) { observer.observe(video); });
})();

} catch (error) { console.warn("Muse source module how-it-works-1", error); }
try {

  document.addEventListener('DOMContentLoaded', function() {
  // Clone every logo strip's contents for a seamless marquee effect
  const logoStrips = Array.from(document.querySelectorAll('.v1-logo-strip:not([data-cloned])')).forEach(function (logoStrip) {
    const logos = logoStrip.querySelector('.v1-logo-strip__list');
    const copies = 1;
    for (var c = 0; c < copies ; c++) {
      Array.from(logos.children).forEach(function(item) {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); // Don't repeat the content for screen readers
        logos.appendChild(clone);
      });
    }
    logoStrip.setAttribute('data-cloned', 'true');
  });
});

} catch (error) { console.warn("Muse source module how-it-works-2", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315188863343__how_slider_bjXM8c';
    var sectionEl = document.getElementById('how-slider-' + sectionId);
    if (!sectionEl) return;

    var slides = sectionEl.querySelectorAll('.how-slider__slide');
    var dots = document.querySelectorAll('#hs-dots-' + sectionId + ' .how-slider__dot');
    var prevBtn = sectionEl.querySelector('.how-slider__arrow--prev');
    var nextBtn = sectionEl.querySelector('.how-slider__arrow--next');
    var currentIndex = 0;
    var autoTimer = null;
    var progressTimer = null;
    var duration = 5000;
    var progressWidth = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      sectionEl.setAttribute('data-active-slide', index);
      slides.forEach(function(slide, i) {
        slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('how-slider__dot--active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.setAttribute('tabindex', i === index ? '0' : '-1');
      });
    }

    function advanceSlide() {
      goTo(currentIndex + 1);
      startProgress();
    }

    function startProgress() {
      return;
    }

    function startAuto() {
      clearInterval(autoTimer);
      startProgress();
    }

    function stopAuto() {
      clearInterval(autoTimer);
      clearInterval(progressTimer);
    }

    function restartAuto() {
      stopAuto();
      startAuto();
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        goTo(idx);
        restartAuto();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goTo(currentIndex - 1);
        restartAuto();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goTo(currentIndex + 1);
        restartAuto();
      });
    }

    sectionEl.addEventListener('click', function(e) {
      if (e.target.closest('.how-slider__dot') || e.target.closest('.how-slider__btn') || e.target.closest('.how-slider__arrow')) return;
      var rect = sectionEl.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      if (clickX > rect.width / 2) {
        goTo(currentIndex + 1);
      } else {
        goTo(currentIndex - 1);
      }
      restartAuto();
    });

    var hsPrev = document.querySelector('.how-slider__nav [data-hs-prev]');
    var hsNext = document.querySelector('.how-slider__nav [data-hs-next]');
    if (hsPrev) {
      hsPrev.addEventListener('click', function () { goTo(currentIndex - 1); });
    }
    if (hsNext) {
      hsNext.addEventListener('click', function () { goTo(currentIndex + 1); });
    }

    goTo(0);
    startAuto();
  })();

} catch (error) { console.warn("Muse source module how-it-works-3", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315188863343__how_cards_hovered_mLj7Rw';
    var spacer = document.getElementById('hch-spacer-' + sectionId);
    var section = document.getElementById('hch-' + sectionId);
    if (!spacer || !section) return;

    var cards = section.querySelectorAll('.hch__card');
    if (cards.length < 2) return;

    var mql = window.matchMedia('(max-width: 767px)');
    var dots = section.querySelectorAll('.hch__dot');
    var currentIndex = 0;
    var autoTimer = null;
    var progressTimer = null;
    var duration = 5000;
    var progressWidth = 0;

    var defaultCard = null;
    cards.forEach(function(card) {
      if (card.classList.contains('is-default')) defaultCard = card;
    });

    var cardRow = section.querySelector('.hch__row');
    if (cardRow && defaultCard) {
      defaultCard.classList.add('is-default--active');
      cardRow.addEventListener('mouseenter', function() {
        defaultCard.classList.remove('is-default--active');
      });
      cardRow.addEventListener('mouseleave', function() {
        defaultCard.classList.add('is-default--active');
      });
    }

    function onMobileChange(e) {
      if (e.matches) {
        spacer.style.height = '';
        goTo(currentIndex);
        startAuto();
      } else {
        stopAuto();
        spacer.style.height = '';
        cards.forEach(function(card) {
          card.removeAttribute('data-active');
        });
      }
    }

    function goTo(index) {
      if (index < 0) index = cards.length - 1;
      if (index >= cards.length) index = 0;
      currentIndex = index;
      cards.forEach(function(card, i) {
        card.setAttribute('data-active', i === index ? 'true' : 'false');
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('hch__dot--active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.setAttribute('tabindex', i === index ? '0' : '-1');
      });
    }

    function startProgress() {
      progressWidth = 0;
      dots.forEach(function(dot) {
        var fill = dot.querySelector('.hch__dot-fill');
        if (fill) fill.style.transform = 'scaleX(0)';
      });
      clearInterval(progressTimer);
      progressTimer = setInterval(function() {
        progressWidth += 100 / (duration / 50);
        var activeDot = dots[currentIndex];
        var activeFill = activeDot && activeDot.querySelector('.hch__dot-fill');
        if (activeFill) activeFill.style.transform = 'scaleX(' + Math.min(progressWidth, 100) / 100 + ')';
      }, 50);
    }

    function startAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function() {
        goTo(currentIndex + 1);
        startProgress();
      }, duration);
      startProgress();
    }

    function stopAuto() {
      clearInterval(autoTimer);
      clearInterval(progressTimer);
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        if (!mql.matches) return;
        goTo(parseInt(dot.getAttribute('data-dot-index'), 10));
        stopAuto();
        startAuto();
      });
    });

    var swipeThreshold = 40;
    var swipeStartX = null;

    function handleSwipe(endX) {
      if (!mql.matches || swipeStartX === null) return;
      var deltaX = endX - swipeStartX;
      swipeStartX = null;
      if (Math.abs(deltaX) < swipeThreshold) return;
      goTo(currentIndex + (deltaX < 0 ? 1 : -1));
      stopAuto();
      startAuto();
    }

    if (window.PointerEvent) {
      cardRow.addEventListener('pointerdown', function(event) {
        if (!mql.matches || event.pointerType === 'mouse') return;
        swipeStartX = event.clientX;
        cardRow.setPointerCapture(event.pointerId);
      });

      cardRow.addEventListener('pointerup', function(event) {
        if (event.pointerType !== 'mouse') handleSwipe(event.clientX);
      });

      cardRow.addEventListener('pointercancel', function() {
        swipeStartX = null;
      });
    } else {
      cardRow.addEventListener('touchstart', function(event) {
        if (!mql.matches || !event.touches.length) return;
        swipeStartX = event.touches[0].clientX;
      }, { passive: true });

      cardRow.addEventListener('touchend', function(event) {
        if (event.changedTouches.length) handleSwipe(event.changedTouches[0].clientX);
      }, { passive: true });

      cardRow.addEventListener('touchcancel', function() {
        swipeStartX = null;
      }, { passive: true });
    }

    mql.addEventListener('change', onMobileChange);
    onMobileChange(mql);
  })();

} catch (error) { console.warn("Muse source module how-it-works-4", error); }
try {

 /* ============================================================
   HOME SCIENCE SECTION — Extracted JavaScript
   ============================================================ */

(function () {
  "use strict";

  /* ---------- DOM References ---------- */
  const scienceDonutValue   = document.getElementById("scienceDonutValue");
  const scienceDonutLabel   = document.getElementById("scienceDonutLabel");
  const scienceDonutSteps   = Array.from(document.querySelectorAll(".science-donut-step"));
  const scienceMetricCopy   = document.querySelector(".science-metric-copy");
  const scienceMetricList   = document.querySelector(".science-metric-list");
  const scienceMetricItems  = Array.from(document.querySelectorAll(".science-metric-item"));

  /* ---------- Config ---------- */
  const config = window.scienceSectionConfig || {};
  const scienceMetricValues = config.metricValues
    ? config.metricValues.map(Number)
    : [77, 72, 20, 78, 72];
  const scienceMetricDuration = config.stepDuration || 4200;
  const scienceMetricRealCount = scienceMetricValues.length;

  let scienceMetricIndex = 0;
  let scienceAutoTimer = null;
  let scienceLoopResetTimer = null;
  const mobileMediaQuery = window.matchMedia("(max-width: 700px)");

  /* ---------- Helpers ---------- */
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  /* ---------- Donut Update ---------- */
  function updateScienceDonut(index) {
    if (!scienceDonutValue || !scienceDonutLabel) return;

    const value  = scienceMetricValues[index % scienceMetricRealCount];
    const radius = Number(scienceDonutValue.getAttribute("r"));
    const circumference = 2 * Math.PI * radius;

    scienceDonutValue.style.strokeDasharray   = `${circumference}`;
    scienceDonutValue.style.strokeDashoffset  = `${circumference * (1 - value / 100)}`;
    scienceDonutLabel.textContent = `${value}%`;

    scienceDonutSteps.forEach((step, stepIndex) => {
      step.classList.toggle("is-complete", stepIndex < index % scienceMetricRealCount);
      step.classList.toggle("is-active", stepIndex === index % scienceMetricRealCount);
      step.style.setProperty("--science-step-duration", `${scienceMetricDuration}ms`);
    });

  }

  /* ---------- Metric Text Scroll ---------- */
  function updateScienceMetricText(index) {
    if (!scienceMetricCopy || !scienceMetricList || !scienceMetricItems.length) return;

    const activeItem = scienceMetricItems[index];
    if (!activeItem) return;

    const isMobile = mobileMediaQuery.matches;
    const copyCenter = (isMobile ? scienceMetricCopy.clientWidth : scienceMetricCopy.clientHeight) / 2;
    const itemCenter = isMobile
      ? activeItem.offsetLeft + activeItem.offsetWidth / 2
      : activeItem.offsetTop + activeItem.offsetHeight / 2;
    const targetOffset = copyCenter - itemCenter;

    scienceMetricList.style.setProperty("--science-copy-y", isMobile ? "0px" : `${targetOffset}px`);
    scienceMetricList.style.setProperty("--science-copy-x", isMobile ? `${targetOffset}px` : "0px");

    scienceMetricItems.forEach((item, itemIndex) => {
      item.classList.toggle("is-active", itemIndex === index);
    });
  }

  /* ---------- Loop Reset (seamless infinite scroll) ---------- */
  function syncScienceMetricLoopPosition() {
    if (!scienceMetricList || scienceMetricIndex !== scienceMetricRealCount) return;

    if (scienceLoopResetTimer) window.clearTimeout(scienceLoopResetTimer);
    scienceLoopResetTimer = null;
    scienceMetricList.style.transition = "none";
    scienceMetricIndex = 0;
    updateScienceDonut(scienceMetricIndex);
    updateScienceMetricText(scienceMetricIndex);
    scienceMetricList.offsetHeight; // force reflow
    scienceMetricList.style.transition = "";
  }

  /* ---------- Auto-cycle step ---------- */
  function advanceScienceMetric() {
    const nextMetricIndex = scienceMetricIndex + 1;
    scienceMetricIndex = nextMetricIndex;
    updateScienceDonut(nextMetricIndex % scienceMetricRealCount);
    updateScienceMetricText(nextMetricIndex);

    if (nextMetricIndex === scienceMetricRealCount) {
      const resetAfterTransition = (event) => {
        if (event.target !== scienceMetricList || event.propertyName !== "transform") return;
        scienceMetricList.removeEventListener("transitionend", resetAfterTransition);
        syncScienceMetricLoopPosition();
      };
      scienceMetricList.addEventListener("transitionend", resetAfterTransition);
      scienceLoopResetTimer = window.setTimeout(() => {
        scienceMetricList.removeEventListener("transitionend", resetAfterTransition);
        syncScienceMetricLoopPosition();
      }, 1700);
    }
  }

  /* ---------- Click a metric item to advance the loop ---------- */
  function goToScienceMetric(targetIndex) {
    if (scienceAutoTimer) window.clearInterval(scienceAutoTimer);
    if (scienceLoopResetTimer) window.clearTimeout(scienceLoopResetTimer);
    scienceMetricIndex = targetIndex;
    updateScienceDonut(targetIndex % scienceMetricRealCount);
    updateScienceMetricText(targetIndex);
    scienceAutoTimer = window.setInterval(advanceScienceMetric, scienceMetricDuration);
  }

  function bindScienceMetricClicks() {
    scienceMetricItems.forEach((item) => {
      item.style.cursor = "pointer";
      item.addEventListener("click", () => {
        /* If the duplicate first item is currently on screen, normalize its
           position before advancing so the next click always moves forward. */
        if (scienceMetricIndex === scienceMetricRealCount) {
          syncScienceMetricLoopPosition();
        }
        advanceScienceMetric();
      });
    });
  }

  /* ---------- Init & Auto-cycle ---------- */
  function initScienceSection() {
    updateScienceDonut(scienceMetricIndex);
    window.requestAnimationFrame(() => updateScienceMetricText(scienceMetricIndex));
    bindScienceMetricClicks();

    scienceAutoTimer = window.setInterval(advanceScienceMetric, scienceMetricDuration);
  }

  /* ---------- Resize / Orientation ---------- */
  function handleResize() {
    updateScienceMetricText(scienceMetricIndex);
  }

  window.addEventListener("resize", handleResize);
  window.addEventListener("orientationchange", () => {
    window.setTimeout(handleResize, 250);
  });
  mobileMediaQuery.addEventListener?.("change", handleResize);

  /* ---------- Boot ---------- */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScienceSection);
  } else {
    initScienceSection();
  }
})();

} catch (error) { console.warn("Muse source module how-it-works-5", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315188863343__how_science_KaJN3w';
    var spacer = document.getElementById('science-mobile-spacer-' + sectionId);
    var section = document.getElementById('science-mobile-' + sectionId);
    if (!spacer || !section) return;

    var slides = section.querySelectorAll('.science-mobile__slide');
    var dots = section.querySelectorAll('.science-mobile__dot');
    var metricValues = [77,72,20,78,72];
    var currentIndex = 0;
    var ticking = false;

    var mql = window.matchMedia('(max-width: 700px)');

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      slides.forEach(function(slide, i) {
        slide.setAttribute('data-active', i === index ? 'true' : 'false');
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      updateDonut(index);
    }

    function updateDonut(index) {
      var value = metricValues[index % metricValues.length];
      var valueCircle = section.querySelector('.science-mobile__donut-value[data-metric-index="' + index + '"]');
      var label = section.querySelector('.science-mobile__donut-label[data-metric-index="' + index + '"]');
      if (valueCircle) {
        var circumference = 772.832;
        valueCircle.style.strokeDashoffset = circumference * (1 - value / 100);
      }
      if (label) {
        label.textContent = value + '%';
      }
    }

    function updateScroll() {
      var scrollStart = spacer.offsetTop;
      var scrollEnd = scrollStart + spacer.offsetHeight - window.innerHeight;
      var scrollRange = Math.max(1, scrollEnd - scrollStart);
      var progress = clamp((window.scrollY - scrollStart) / scrollRange, 0, 1);
      var slideIndex = Math.round(progress * (slides.length - 1));
      if (slideIndex !== currentIndex) {
        goTo(slideIndex);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        updateScroll();
        ticking = false;
      });
    }

    function onMobileChange(e) {
      if (e.matches) {
        spacer.style.height = (slides.length * 100) + 'vh';
        window.addEventListener('scroll', onScroll, { passive: true });
        goTo(0);
      } else {
        spacer.style.height = '';
        window.removeEventListener('scroll', onScroll);
      }
    }

    mql.addEventListener('change', onMobileChange);
    onMobileChange(mql);
  })();

} catch (error) { console.warn("Muse source module how-it-works-6", error); }
try {

(function() {
  'use strict';

  var sectionId = 'template--26315188863343__how_cards_compare_BLwAHh';
  var sectionEl = document.getElementById('hcc-' + sectionId);
  if (!sectionEl) return;

  var popup = document.getElementById('hcc-popup-' + sectionId);
  if (!popup) return;

  var btns = sectionEl.querySelectorAll('.hcc__card-btn[data-popup]');

  function openPopup() {
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  btns.forEach(function(btn) {
    btn.addEventListener('click', openPopup);
  });

  sectionEl.querySelectorAll('[data-close-popup]').forEach(function(el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });
})();

} catch (error) { console.warn("Muse source module how-it-works-7", error); }
},
"benefits":function(document,window){
try {

(function () {

  var buttons = document.querySelectorAll('.v1-hero .patrol-video__button');

  if (!buttons.length) return;

  buttons.forEach(function (button) {
    var root = button.closest('.v1-hero');
    var videos = root ? root.querySelectorAll('video') : [];

    if (!videos.length) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      paused ? 'Play background video' : 'Pause background video'
    );
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction = false) {
    videos.forEach(video => {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction = false) {
    videos.forEach(video => {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(() => {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  // button click
  button.addEventListener('click', function () {
    const anyPlaying = Array.from(videos).some(v => !v.paused);
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });
  // ⭐ IMPORTANT — prevent autoplay after scroll / visibility
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;

      if (video.dataset.userPaused === 'true') return;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(video => observer.observe(video));
  });
})();

} catch (error) { console.warn("Muse source module benefits-1", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315192140143__benefits_cards_stats_RXPRPn';
    var section = document.getElementById('bcs-' + sectionId);
    if (!section) return;

    var slides = section.querySelectorAll('.bcs__slide');
    var dots = section.querySelectorAll('.bcs__dot');
    var currentIndex = 0;
    var autoTimer = null;
    var autoDuration = 5000;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      section.setAttribute('data-active-slide', index);
      slides.forEach(function(slide, i) {
        slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function nextSlide() {
      goTo(currentIndex + 1);
    }

    function startAutoCycle() {
      stopAutoCycle();
      autoTimer = setInterval(nextSlide, autoDuration);
    }

    function stopAutoCycle() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        stopAutoCycle();
        goTo(i);
        startAutoCycle();
      });
    });

    startAutoCycle();
  })();

} catch (error) { console.warn("Muse source module benefits-2", error); }
try {

  (function () {
    'use strict';

    /* ---------- DOM References ---------- */
    var donutValue   = document.getElementById('bscDonutValue');
    var donutLabel   = document.getElementById('bscDonutLabel');
    var donutSteps   = Array.from(document.querySelectorAll('.bsc-donut-step'));
    var metricCopy   = document.querySelector('.bsc-metric-copy');
    var metricList   = document.querySelector('.bsc-metric-list');
    var metricItems  = Array.from(document.querySelectorAll('.bsc-metric-item'));

    var config = window.bscSectionConfig || {};
    var metricValues = config.metricValues
      ? config.metricValues.map(Number)
      : [77, 72, 20, 78, 72];
    var metricDuration = config.stepDuration || 4200;
    var metricRealCount = metricValues.length;

    var metricIndex = 0;
    var bscAutoTimer = null;
    var bscLoopResetTimer = null;
    var mobileMediaQuery = window.matchMedia('(max-width: 700px)');

    function updateDonut(index) {
      if (!donutValue || !donutLabel) return;

      var value = metricValues[index % metricRealCount];
      var radius = Number(donutValue.getAttribute('r'));
      var circumference = 2 * Math.PI * radius;

      donutValue.style.strokeDasharray = circumference;
      donutValue.style.strokeDashoffset = circumference * (1 - value / 100);
      donutLabel.textContent = value + '%';

      donutSteps.forEach(function(step, stepIndex) {
        step.classList.toggle('is-complete', stepIndex < index % metricRealCount);
        step.classList.toggle('is-active', stepIndex === index % metricRealCount);
        step.style.setProperty('--bsc-step-duration', metricDuration + 'ms');
      });

      updateMetricText(index % metricRealCount);
    }

    function updateMetricText(index) {
      if (!metricCopy || !metricList || !metricItems.length) return;

      var activeItem = metricItems[index];
      if (!activeItem) return;

      var isMobile = mobileMediaQuery.matches;
      var copyCenter = (isMobile ? metricCopy.clientWidth : metricCopy.clientHeight) / 2;
      var itemCenter = isMobile
        ? activeItem.offsetLeft + activeItem.offsetWidth / 2
        : activeItem.offsetTop + activeItem.offsetHeight / 2;
      var targetOffset = copyCenter - itemCenter;

      metricList.style.setProperty('--bsc-copy-y', isMobile ? '0px' : targetOffset + 'px');
      metricList.style.setProperty('--bsc-copy-x', isMobile ? targetOffset + 'px' : '0px');

      metricItems.forEach(function(item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });
    }

    function syncLoopPosition() {
      if (!metricList || metricIndex !== metricRealCount) return;

      if (bscLoopResetTimer) window.clearTimeout(bscLoopResetTimer);
      bscLoopResetTimer = null;
      metricList.style.transition = 'none';
      metricIndex = 0;
      updateDonut(metricIndex);
      updateMetricText(metricIndex);
      metricList.offsetHeight;
      metricList.style.transition = '';
    }

    function advanceMetric() {
      var nextIndex = metricIndex + 1;
      metricIndex = nextIndex;
      updateDonut(nextIndex % metricRealCount);
      updateMetricText(nextIndex);

      if (nextIndex === metricRealCount) {
        var resetAfterTransition = function(event) {
          if (event.target !== metricList || event.propertyName !== 'transform') return;
          metricList.removeEventListener('transitionend', resetAfterTransition);
          syncLoopPosition();
        };
        metricList.addEventListener('transitionend', resetAfterTransition);
        bscLoopResetTimer = window.setTimeout(function() {
          metricList.removeEventListener('transitionend', resetAfterTransition);
          syncLoopPosition();
        }, 1700);
      }
    }

    function goToMetric(index) {
      if (bscAutoTimer) window.clearInterval(bscAutoTimer);
      if (bscLoopResetTimer) window.clearTimeout(bscLoopResetTimer);
      metricIndex = index;
      updateDonut(index % metricRealCount);
      updateMetricText(index);
      bscAutoTimer = window.setInterval(advanceMetric, metricDuration);
    }

    function bindMetricClicks() {
      metricItems.forEach(function(item) {
        item.style.cursor = 'pointer';
        item.addEventListener('click', function() {
          if (metricIndex === metricRealCount) {
            syncLoopPosition();
          }
          advanceMetric();
        });
      });
    }

    function init() {
      updateDonut(metricIndex);
      window.requestAnimationFrame(function() { updateMetricText(metricIndex); });
      bindMetricClicks();

      bscAutoTimer = window.setInterval(advanceMetric, metricDuration);
    }

    function handleResize() {
      updateMetricText(metricIndex);
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', function() {
      window.setTimeout(handleResize, 250);
    });
    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener('change', handleResize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

} catch (error) { console.warn("Muse source module benefits-3", error); }
try {

  (function () {
    'use strict';

    var sectionId = 'template--26315192140143__benefit_science_bwpRTL';
    var section = document.getElementById('bsc-mobile-' + sectionId);

    if (!section) return;

    var slides = Array.from(
      section.querySelectorAll('.bsc-mobile__slide')
    );

    var dots = Array.from(
      section.querySelectorAll('.bsc-mobile__dot')
    );

    var metricValues = [
      77,72,20,78,72
    ].map(Number);

    var duration = Number(
      3000
    );

    var currentIndex = 0;
    var timer;

    if (!slides.length || !dots.length) return;

    function getCircle(index) {
      return section.querySelector(
        '.bsc-mobile__donut .bsc-donut-value[data-metric-index="' +
        index +
        '"]'
      );
    }

    function getLabel(index) {
      return section.querySelector(
        '.bsc-mobile__donut-label[data-metric-index="' +
        index +
        '"]'
      );
    }

    function getCircumference(circle) {
      var radius = Number(circle.getAttribute('r'));
      return 2 * Math.PI * radius;
    }

    function setDonutToStart(index) {
      var circle = getCircle(index);

      if (!circle) return;

      var circumference = getCircumference(circle);

      circle.style.strokeDasharray = circumference;
      circle.style.strokeDashoffset = circumference;
    }

    function animateDonut(index) {
      var circle = getCircle(index);
      var label = getLabel(index);

      if (!circle) return;

      var value = Number(metricValues[index] || 0);
      var circumference = getCircumference(circle);
      var finalOffset = circumference * (1 - value / 100);

      circle.style.strokeDasharray = circumference;

      /*
       * First place the donut at zero.
       */
      circle.style.transition = 'none';
      circle.style.strokeDashoffset = circumference;

      /*
       * Force the browser to apply the zero state before
       * starting the transition.
       */
      circle.getBoundingClientRect();

      /*
       * Restore the transition and animate to the final value.
       */
      circle.style.transition =
        'stroke-dashoffset 1600ms cubic-bezier(0.22, 1, 0.36, 1)';

      window.requestAnimationFrame(function () {
        circle.style.strokeDashoffset = finalOffset;
      });

      if (label) {
        label.textContent = value + '%';
      }
    }

    function restartDotAnimation(dot) {
      /*
       * Removing and re-adding the class, together with a forced
       * reflow, guarantees that the progress animation restarts.
       */
      dot.classList.remove('is-active');
      dot.offsetWidth;
      dot.style.setProperty(
        '--bsc-mobile-duration',
        duration + 'ms'
      );
      dot.classList.add('is-active');
    }

    function updateProgress(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-complete', dotIndex < index);
        dot.classList.remove('is-active');
      });

      var activeDot = dots[index];

      if (activeDot) {
        restartDotAnimation(activeDot);
      }
    }

    function showSlide(index, shouldAnimate) {
      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;

      /*
       * Put the new donut at zero before displaying its slide.
       * This is the key fix for the mobile animation.
       */
      setDonutToStart(index);

      section.setAttribute('data-active-slide', String(index));
      updateProgress(index);

      /*
       * Wait until the slide is visible, then animate the donut.
       */
      window.requestAnimationFrame(function () {
        if (shouldAnimate) {
          animateDonut(index);
        } else {
          var circle = getCircle(index);

          if (!circle) return;

          var value = Number(metricValues[index] || 0);
          var circumference = getCircumference(circle);

          circle.style.transition = 'none';
          circle.style.strokeDasharray = circumference;
          circle.style.strokeDashoffset =
            circumference * (1 - value / 100);

          var label = getLabel(index);

          if (label) {
            label.textContent = value + '%';
          }
        }
      });
    }

    var isPaused = false;

    function startSlider() {
      window.clearInterval(timer);

      if (isPaused) return;

      timer = window.setInterval(function () {
        showSlide(currentIndex + 1, true);
      }, duration);
    }

    function togglePause() {
      isPaused = !isPaused;

      if (isPaused) {
        window.clearInterval(timer);
      } else {
        startSlider();
      }
    }

    /*
     * Initialize the first slide.
     */
    showSlide(0, true);
    startSlider();

    section.addEventListener('click', function () {
      togglePause();
    });

    /*
     * Avoid multiple timers when the page is restored from
     * the browser back/forward cache.
     */
    window.addEventListener('pagehide', function () {
      window.clearInterval(timer);
    });

    window.addEventListener('pageshow', function () {
      startSlider();
    });
  })();

} catch (error) { console.warn("Muse source module benefits-4", error); }
},
"research":function(document,window){
try {

  (function() {
    'use strict';

    var section = document.querySelector('.research-study-cards');
    if (!section) return;

    var cards = Array.from(section.querySelectorAll('.research-study-card'));
    var dots = Array.from(section.querySelectorAll('.research-study-cards__dot'));
    var currentIndex = 0;
    var autoTimer = null;
    var autoDuration = 5000;

    function goTo(index) {
      if (index < 0) index = cards.length - 1;
      if (index >= cards.length) index = 0;
      currentIndex = index;
      cards.forEach(function(card, i) {
        card.classList.toggle('is-active', i === index);
      });
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function nextSlide() {
      goTo(currentIndex + 1);
    }

    function startAutoCycle() {
      stopAutoCycle();
      autoTimer = setInterval(nextSlide, autoDuration);
    }

    function stopAutoCycle() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        stopAutoCycle();
        goTo(i);
        startAutoCycle();
      });
    });

    cards.forEach(function(card, i) {
      card.addEventListener('click', function() {
        if (i === currentIndex) return;
        stopAutoCycle();
        goTo(i);
        startAutoCycle();
      });
    });

    startAutoCycle();
  })();

} catch (error) { console.warn("Muse source module research-1", error); }
},
"app":function(document,window){
try {

            /* This convoluted code removes everything AC injects in terms of CSS once it has loaded, so we can style the form as we wish */
            document.addEventListener('muse:script-loaded', function(e) {
              if (e.target.src === `https://interaxon.activehosted.com/f/embed.php?id=422`) {
                var targetEl = document.querySelector(`._form_422`);
                var removeStyleInterval = setInterval(function(e) {
                  if (targetEl.children.length === 0) { return; }
                  Array.from(targetEl.querySelectorAll(':scope > style')).forEach(function (style) {
                    targetEl.removeChild(style);
                  });
                  if (targetEl.querySelectorAll(':scope > style').length === 0) {
                    clearInterval(removeStyleInterval);
                  }
                }, 200);
              }
            })
} catch (error) { console.warn("Muse source module app-1", error); }
},
"reviews":function(document,window){
try {

(function () {
  var section = document.getElementById('premium-hero-template--26315189944687__premium_hero_QcmwJW');
  if (!section) return;

  var videos = section.querySelectorAll('video.premium-hero__video');
  var button = section.querySelector('.patrol-video__button');

  if (!videos.length || !button) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(function() {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  button.addEventListener('click', function () {
    var anyPlaying = Array.prototype.some.call(videos, function(v) { return !v.paused; });
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var video = entry.target;
      if (video.dataset.userPaused === 'true') return;
      if (entry.isIntersecting) {
        video.play().catch(function() {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(function(video) { observer.observe(video); });
})();

} catch (error) { console.warn("Muse source module reviews-1", error); }
try {

(function() {
  var track = document.getElementById('kfLogos-template--26315189944687__known_from_Tj8kQz');
  if (!track) return;

  var mq = window.matchMedia('(max-width: 576px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var clones = [];
  var rafId = null;
  var scrolling = false;
  var SPEED = 1.0; // px per frame

  function removeClones() {
    clones.forEach(function(c) { c.remove(); });
    clones = [];
    track.scrollLeft = 0;
  }

  function addClones() {
    removeClones();
    var cards = Array.prototype.slice.call(track.querySelectorAll('.known-from__logo-card:not(.is-clone)'));
    if (cards.length < 2) return;
    // one full duplicate set is enough for a seamless wrap
    cards.forEach(function(card) {
      var clone = card.cloneNode(true);
      clone.classList.add('is-clone');
      clone.removeAttribute('data-shopify-editor-block');
      track.appendChild(clone);
      clones.push(clone);
    });
  }

  function step() {
    if (!scrolling) return;
    var setWidth = track.scrollWidth / 2;
    if (setWidth > 0) {
      track.scrollLeft += SPEED;
      if (track.scrollLeft >= setWidth) {
        track.scrollLeft -= setWidth;
      }
    }
    rafId = requestAnimationFrame(step);
  }

  function start() {
    if (scrolling || reduceMotion.matches) return;
    scrolling = true;
    rafId = requestAnimationFrame(step);
  }

  function stop() {
    scrolling = false;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
  }

  // pause when the section scrolls out of view
  var visible = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      visible = entries[0].isIntersecting;
      if (visible && mq.matches) start(); else stop();
    }, { threshold: 0 }).observe(track);
  }

  function onBreakpointChange() {
    if (mq.matches) {
      addClones();
      if (visible) start();
    } else {
      stop();
      removeClones();
    }
  }

  // pause when tab hidden
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) stop();
    else if (mq.matches && visible) start();
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', onBreakpointChange);
    reduceMotion.addEventListener('change', onBreakpointChange);
  } else {
    mq.addListener(onBreakpointChange);
  }

  onBreakpointChange();
  // swipe support
  var touchStartX = 0;
  var touchDelta = 0;
  var swiping = false;

  track.addEventListener('touchstart', function(e) {
    if (!mq.matches) return;
    touchStartX = e.touches[0].clientX;
    touchDelta = 0;
    swiping = true;
    stop();
  }, { passive: true });

  track.addEventListener('touchmove', function(e) {
    if (!swiping) return;
    touchDelta = e.touches[0].clientX - touchStartX;
  }, { passive: true });

  track.addEventListener('touchend', function() {
    if (!swiping) return;
    swiping = false;
    var cards = track.querySelectorAll('.known-from__logo-card:not(.is-clone)');
    if (cards.length === 0) { if (visible) start(); return; }
    var cardWidth = cards[0].offsetWidth;
    var threshold = cardWidth * 0.25;
    if (Math.abs(touchDelta) > threshold) {
      var dir = touchDelta < 0 ? 1 : -1;
      track.scrollLeft += dir * cardWidth;
    }
    if (visible) start();
  });
})();

} catch (error) { console.warn("Muse source module reviews-2", error); }
try {

  (function() {
    'use strict';

    var researchStatsDoughnutValue = document.getElementById('researchStatsDoughnutValue');
    var researchStatsDoughnutLabel = document.getElementById('researchStatsDoughnutLabel');
    var progressSteps = Array.from(document.querySelectorAll('.research-stats-dashboard__progress-step'));
    var metricItems = Array.from(document.querySelectorAll('.research-stats-dashboard__metric-item'));

    if (!researchStatsDoughnutValue || !metricItems.length) return;

    var metricValues = [78,43,20,88];
    var metricIndex = 0;
    var metricDuration = 4200;
    var metricRealCount = metricValues.length;
    var metricTimer = null;

    function updateDonut(index) {
      if (!researchStatsDoughnutValue) return;

      var value = metricValues[index % metricRealCount];
      var radius = Number(researchStatsDoughnutValue.getAttribute('r'));
      var circumference = 2 * Math.PI * radius;

      researchStatsDoughnutValue.style.strokeDasharray = circumference;
      researchStatsDoughnutValue.style.strokeDashoffset = circumference * (1 - value / 100);
      researchStatsDoughnutLabel.textContent = value + '%';

      progressSteps.forEach(function(step, stepIndex) {
        step.classList.toggle('is-complete', stepIndex < index % metricRealCount);
        step.classList.toggle('is-active', stepIndex === index % metricRealCount);
        step.style.setProperty('--research-stats-step-duration', metricDuration + 'ms');
      });

      updateMetricOpacity(index % metricRealCount);
    }

    function updateMetricOpacity(index) {
      metricItems.forEach(function(item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });
    }

    function syncLoopPosition() {
      if (metricIndex !== metricRealCount) return;

      metricIndex = 0;
      updateDonut(metricIndex);
      updateMetricOpacity(metricIndex);
    }

    function advanceMetric() {
      var nextIndex = metricIndex + 1;
      metricIndex = nextIndex;
      updateDonut(nextIndex % metricRealCount);
      updateMetricOpacity(nextIndex % metricRealCount);

      if (nextIndex === metricRealCount) {
        window.setTimeout(syncLoopPosition, 1700);
      }
    }

    function goToMetric(index) {
      if (metricTimer) window.clearInterval(metricTimer);
      metricIndex = index;
      updateDonut(index % metricRealCount);
      updateMetricOpacity(index % metricRealCount);
      metricTimer = window.setInterval(advanceMetric, metricDuration);
    }

    function bindMetricClicks() {
      metricItems.forEach(function(item, index) {
        item.style.cursor = 'pointer';
        item.addEventListener('click', function() {
          goToMetric(index);
        });
      });
    }

    function init() {
      updateDonut(0);
      updateMetricOpacity(0);
      bindMetricClicks();

      metricTimer = window.setInterval(advanceMetric, metricDuration);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

} catch (error) { console.warn("Muse source module reviews-3", error); }
try {

(function() {
  var sectionId = 'template--26315189944687__shop_testimonial_3mjR96';
  var section = document.querySelector('[data-shop-testimonial="' + sectionId + '"]');
  if (!section) section = document.querySelector('.testimonials-section');

  var track = section.querySelector('.testimonials__track');
  var bullets = section.querySelectorAll('.testimonials__bullet');

  if (!track || !bullets.length) return;

  function setActive(index) {
    bullets.forEach(function(bullet, i) {
      bullet.classList.toggle('is-active', i === index);
    });
  }

  function goToSlide(index) {
    if (index < 0 || index >= bullets.length) return;

    var card = section.querySelectorAll('.testimonial-card')[index];
    if (!card) return;

    /* Center the card within the track viewport */
    var targetLeft = card.offsetLeft - track.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    track.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });

    setActive(index);
  }

  bullets.forEach(function(bullet) {
    bullet.addEventListener('click', function() {
      goToSlide(parseInt(this.getAttribute('data-index'), 10));
    });
  });

  var scrollTimer;

  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(function() {
      var cards = section.querySelectorAll('.testimonial-card');
      var scrollCenter = track.scrollLeft + track.clientWidth / 2;

      /* Find the card whose center is closest to the viewport center */
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function(card, i) {
        var cardCenter = card.offsetLeft - track.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - scrollCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = i;
        }
      });

      setActive(nearestIndex);
    }, 80);
  });
})();

} catch (error) { console.warn("Muse source module reviews-4", error); }
},
"premium":function(document,window){
try {

(function () {
  var section = document.getElementById('premium-hero-template--26315188830575__premium_hero_QcmwJW');
  if (!section) return;

  var videos = section.querySelectorAll('video.premium-hero__video');
  var button = section.querySelector('.patrol-video__button');

  if (!videos.length || !button) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(function() {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  button.addEventListener('click', function () {
    var anyPlaying = Array.prototype.some.call(videos, function(v) { return !v.paused; });
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var video = entry.target;
      if (video.dataset.userPaused === 'true') return;
      if (entry.isIntersecting) {
        video.play().catch(function() {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(function(video) { observer.observe(video); });
})();

} catch (error) { console.warn("Muse source module premium-1", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315188830575__premium_wakeup_xANpdB';
    var section = document.getElementById('premium-wakeup-' + sectionId);
    if (!section) return;

    var slides = section.querySelectorAll('.premium-wakeup__slide');
    var texts = section.querySelectorAll('.premium-wakeup__text');
    var pills = section.querySelectorAll('.premium-wakeup__pill');
    var scope = section.parentElement;
    var dots = scope.querySelectorAll('.premium-wakeup__dot');
    var fills = scope.querySelectorAll('.premium-wakeup__dot__fill');
    var autoplay = true;
    var intervalMs = 5000;
    var transitionMs = 500;
    var currentIndex = 0;
    var timer = null;

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      section.setAttribute('data-active-slide', index);

      slides.forEach(function(slide, i) {
        slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
      });

      pills.forEach(function(pill, i) {
        pill.setAttribute('aria-selected', i === index ? 'true' : 'false');
        pill.setAttribute('tabindex', i === index ? '0' : '-1');
      });

      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.setAttribute('tabindex', i === index ? '0' : '-1');
      });
    }

    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-slide-index'), 10);
        goTo(idx);
        resetAutoplay();
      });

      pill.addEventListener('keydown', function(e) {
        var idx = parseInt(this.getAttribute('data-slide-index'), 10);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(idx + 1);
          pills[Math.min(idx + 1, pills.length - 1)]?.focus();
          resetAutoplay();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(idx - 1);
          pills[Math.max(idx - 1, 0)]?.focus();
          resetAutoplay();
        } else if (e.key === 'Home') {
          e.preventDefault();
          goTo(0);
          pills[0]?.focus();
          resetAutoplay();
        } else if (e.key === 'End') {
          e.preventDefault();
          goTo(pills.length - 1);
          pills[pills.length - 1]?.focus();
          resetAutoplay();
        }
      });
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-slide-index'), 10);
        goTo(idx);
        resetAutoplay();
      });

      dot.addEventListener('keydown', function(e) {
        var idx = parseInt(this.getAttribute('data-slide-index'), 10);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(idx + 1);
          dots[Math.min(idx + 1, dots.length - 1)]?.focus();
          resetAutoplay();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(idx - 1);
          dots[Math.max(idx - 1, 0)]?.focus();
          resetAutoplay();
        } else if (e.key === 'Home') {
          e.preventDefault();
          goTo(0);
          dots[0]?.focus();
          resetAutoplay();
        } else if (e.key === 'End') {
          e.preventDefault();
          goTo(dots.length - 1);
          dots[dots.length - 1]?.focus();
          resetAutoplay();
        }
      });
    });

    function next() {
      goTo(currentIndex + 1);
    }

    function resetProgress() {
      fills.forEach(function(fill) {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(0)';
      });
    }

    function startProgress() {
      if (!autoplay || slides.length <= 1) return;
      resetProgress();
      var fill = dots[currentIndex] ? dots[currentIndex].querySelector('.premium-wakeup__dot__fill') : null;
      if (!fill) return;
      fill.offsetHeight;
      fill.style.transition = 'transform ' + intervalMs + 'ms linear';
      fill.style.transform = 'scaleX(1)';
    }

    function startAutoplay() {
      return;
    }

    function resetAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      startAutoplay();
    }

    function stopProgress() {
      fills.forEach(function(fill) {
        fill.style.transition = 'none';
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      stopProgress();
    }

    var prevBtn = scope.querySelector('[data-pw-prev]');
    var nextBtn = scope.querySelector('[data-pw-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });
    }

  })();

} catch (error) { console.warn("Muse source module premium-2", error); }
try {

(function() {
  var section = document.getElementById('premium-pricing-template--26315188830575__premium_pricing_Ur8VVJ');
  if (!section) return;

  var container = section.querySelector('.premium-pricing__track');
  var cards = container ? container.querySelectorAll('.main-pricing-card') : [];
  var dotsContainer = section.querySelector('#pricing-dots-template--26315188830575__premium_pricing_Ur8VVJ');
  if (!container || !cards.length || !dotsContainer) return;

  // Create dots
  for (var i = 0; i < cards.length; i++) {
    var dot = document.createElement('button');
    dot.className = 'pricing-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.dataset.index = i;
    dotsContainer.appendChild(dot);
  }

  var dots = dotsContainer.querySelectorAll('.pricing-dot');

  // Update active dot on scroll
  container.addEventListener('scroll', function() {
    var scrollLeft = container.scrollLeft;
    var cardWidth = cards[0].offsetWidth + 16; // card width + gap
    var activeIndex = Math.round(scrollLeft / cardWidth);
    activeIndex = Math.max(0, Math.min(activeIndex, cards.length - 1));

    dots.forEach(function(d, idx) {
      d.classList.toggle('active', idx === activeIndex);
    });
  });

  // Click on dot to scroll
  dotsContainer.addEventListener('click', function(e) {
    var dot = e.target.closest('.pricing-dot');
    if (!dot) return;
    var index = parseInt(dot.dataset.index);
    var cardWidth = cards[0].offsetWidth + 16;
    container.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
  });
})();

} catch (error) { console.warn("Muse source module premium-3", error); }
try {

    (function() {
      const sectionId = "template--26315188830575__prem_compaire_tBhD4y";
      const container = document.querySelector('.muse-cmp--' + sectionId);
      if (!container) return;

      /* 1) Collapsible feature groups ------------------------------------ */
      const groupButtons = container.querySelectorAll('[data-group-toggle]');
      groupButtons.forEach(function(button) {
        const groupId = button.getAttribute('data-group-toggle');
        const content = container.querySelector('[data-group-content="' + groupId + '"]');
        if (!content) return;
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          const newExpanded = !isExpanded;
          button.setAttribute('aria-expanded', newExpanded);
          if (newExpanded) {
            content.style.display = '';
          } else {
            content.style.display = 'none';
          }
        });
      });

      /* 2) Mobile variant switch + content swap --------------------------- */
      const switchEl   = container.querySelector('.muse-cmp__switch');
      const indicator  = switchEl ? switchEl.querySelector('.switch-indicator') : null;
      const tabs       = switchEl ? Array.from(switchEl.querySelectorAll('.variant-tab')) : [];
      const BUNDLE_GROUP = 0; // Muse S Athena (featured)
      const SOLO_GROUP   = 1; // Muse 2

      // Frozen snapshot of original slot content (rows + header), captured once.
      let cmpStorage = null;   // Map<HTMLElement, string>
      let cmpHeaderCells = [];
      let cmpRows = [];

      function cmpCacheOriginals() {
        if (cmpStorage) return;                       // run once per page
        const table = document.querySelector('.muse-cmp__table');
        if (!table) return;

        cmpHeaderCells = Array.from(
          table.querySelectorAll('.muse-cmp__header .muse-cmp__cell--product')
        );
        cmpRows = Array.from(table.querySelectorAll('.muse-cmp__row'));

        cmpStorage = new Map();
        cmpHeaderCells.forEach(function(c) { cmpStorage.set(c, c.innerHTML); });
        cmpRows.forEach(function(row) {
          Array.from(row.querySelectorAll('.muse-cmp__cell--status')).forEach(function(c) {
            cmpStorage.set(c, c.innerHTML);
          });
        });
      }

      /* Swap the content of the two slots that are always visible on mobile
         (product header cells 3&4, and the status cell 3&4 in every row)
         from the frozen originals of the selected group. */
      const SLOT = [2, 3];  // column indices that stay rendered on mobile

      function cmpSwap(target, source, featuredSlot) {
        const html = cmpStorage.get(source);
        if (html === undefined) return;
        target.innerHTML = html;

        // keep the name readable / correctly coloured in the dark featured column
        const name = target.querySelector(featuredSlot
          ? '.muse-cmp__product-name'
          : '.muse-cmp__product-name--featured');
        if (featuredSlot && name) name.classList.add('muse-cmp__product-name--featured');
        if (!featuredSlot && name) name.classList.remove('muse-cmp__product-name--featured');
      }

      function cmpSync(group) {
        cmpCacheOriginals();
        if (!cmpStorage) return;

        let src;
        if (group === SOLO_GROUP) {
          src = [0, 1];        // Muse + Muse 2
        } else {
          src = [2, 3];        // Muse S Athena + Muse S Athena (featured)
        }

        // header product cells
        const solo = group === SOLO_GROUP;
        cmpSwap(cmpHeaderCells[2], cmpHeaderCells[src[0]], false);
        cmpSwap(cmpHeaderCells[3], cmpHeaderCells[src[1]], true);
        if (cmpHeaderCells[3]) {
          cmpHeaderCells[3].style.setProperty('background-color', solo ? '#efeff1' : '', 'important');
        }
        cmpHeaderCells.forEach(function(c, i) {
          c.style.display = SLOT.indexOf(i) !== -1 ? '' : 'none';
        });

        // status cells in every row
        cmpRows.forEach(function(row) {
          const sc = Array.from(row.querySelectorAll('.muse-cmp__cell--status'));
          cmpSwap(sc[2], sc[src[0]], false);
          cmpSwap(sc[3], sc[src[1]], true);
          sc.forEach(function(c, i) {
            c.style.display = SLOT.indexOf(i) !== -1 ? '' : 'none';
          });
        });
      }

      function cmpReset() {
        if (!cmpStorage) return;
        cmpStorage.forEach(function(html, el) { el.innerHTML = html; });
        cmpStorage = null;                            // allow re-init next mobile entry
        cmpHeaderCells.forEach(function(c) {
          c.style.display = '';
          c.style.setProperty('background-color', '', 'important');  // clear solo bg
        });
        cmpRows.forEach(function(row) {
          Array.from(row.querySelectorAll('.muse-cmp__cell--status')).forEach(function(c) {
            c.style.display = '';
          });
        });
        cmpHeaderCells = [];
        cmpRows = [];
      }

      /* public API — used by the variant-switch section script */
      window.initCompareTableSync = cmpCacheOriginals;
      window.syncCompareTable     = cmpSync;
      window.resetCompareTable    = cmpReset;

      /* 3) Tab interaction: move indicator + sync the table on mobile ------ */
      function tabToGroup(tab) {
        return tab.getAttribute('data-variant-tab') === 'solo' ? SOLO_GROUP : BUNDLE_GROUP;
      }

      function setIndicator(tab) {
        if (!indicator || !switchEl) return;
        const idx = Math.max(0, tabs.indexOf(tab));
        indicator.style.transform = 'translateX(' + (idx * 100) + '%)';
        tabs.forEach(function(t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
      }

      function activeGroup() {
        const selected = tabs.filter(function(t) {
          return t.getAttribute('aria-selected') === 'true';
        })[0];
        return selected ? tabToGroup(selected) : BUNDLE_GROUP;
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          setIndicator(tab);
          window.syncCompareTable(tabToGroup(tab));
        });
      });

      /* 4) Sync on mobile entry; restore all columns on leaving mobile ----- */
      const mq = window.matchMedia('(max-width: 768px)');
      function onMobile(e) {
        if (typeof window.syncCompareTable === 'function' && typeof window.resetCompareTable === 'function') {
          if (e.matches) {
            window.syncCompareTable(activeGroup());
          } else {
            window.resetCompareTable();   // leaving mobile → show all columns
          }
        }
      }
      onMobile(mq);
      mq.addEventListener('change', onMobile);
      document.addEventListener('muse:cmp-rows-updated', function() { onMobile(mq); });
    })();
  
} catch (error) { console.warn("Muse source module premium-5", error); }
try {

  (function() {
    'use strict';

    var sectionId = 'template--26315188830575__premium_cards_slide_LiEkU9';
    var section = document.getElementById('premium-cards-slide-' + sectionId);
    if (!section) return;

    var textSlides = section.querySelectorAll('.pcs-text__slide');
    var phoneSlides = section.querySelectorAll('.pcs-slide');
    var dots = section.querySelectorAll('.pcs-dot');
    var fills = section.querySelectorAll('.pcs-dot__fill');
    var autoplay = null;
    var intervalMs = 5000;
    var currentIndex = 0;
    var timer = null;
    var total = phoneSlides.length;

    function getPrev(i) { return (i - 1 + total) % total; }
    function getNext(i) { return (i + 1) % total; }

    function updateClasses() {
      phoneSlides.forEach(function(slide, i) {
        slide.classList.remove('is-active', 'is-prev', 'is-next');
        if (i === currentIndex) {
          slide.classList.add('is-active');
        } else if (i === getPrev(currentIndex)) {
          slide.classList.add('is-prev');
        } else if (i === getNext(currentIndex)) {
          slide.classList.add('is-next');
        }
      });

      textSlides.forEach(function(text, i) {
        text.classList.toggle('is-active', i === currentIndex);
      });

      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex ? 'true' : 'false');
        dot.setAttribute('tabindex', i === currentIndex ? '0' : '-1');
      });
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;
      updateClasses();
      
    }

    function resetProgress() {
      fills.forEach(function(fill) {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(0)';
      });
    }

    function startProgress() {
      if (!autoplay || total <= 1) return;
      resetProgress();
      var fill = dots[currentIndex] ? dots[currentIndex].querySelector('.pcs-dot__fill') : null;
      if (!fill) return;
      fill.offsetHeight;
      fill.style.transition = 'transform ' + intervalMs + 'ms linear';
      fill.style.transform = 'scaleX(1)';
    }

    function stopProgress() {
      fills.forEach(function(fill) {
        fill.style.transition = 'none';
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(this.getAttribute('data-slide-index'), 10));
        resetAutoplay();
      });

      dot.addEventListener('keydown', function(e) {
        var idx = parseInt(this.getAttribute('data-slide-index'), 10);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(idx + 1);
          dots[Math.min(idx + 1, dots.length - 1)]?.focus();
          resetAutoplay();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(idx - 1);
          dots[Math.max(idx - 1, 0)]?.focus();
          resetAutoplay();
        } else if (e.key === 'Home') {
          e.preventDefault();
          goTo(0);
          dots[0]?.focus();
          resetAutoplay();
        } else if (e.key === 'End') {
          e.preventDefault();
          goTo(dots.length - 1);
          dots[dots.length - 1]?.focus();
          resetAutoplay();
        }
      });
    });

    function next() { goTo(currentIndex + 1); }

    function startAutoplay() {
      return;
    }

    function resetAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
      startAutoplay();
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
      stopProgress();
    }

    // Swipe
    var startX = 0;
    var isDragging = false;
    var stage = section.querySelector('.pcs-stage');

    if (stage) {
      stage.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        isDragging = true;
        stopAutoplay();
      }, { passive: true });

      stage.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
        }
      }, { passive: true });
    }

    var prevBtn = section.querySelector('[data-pcs-prev]');
    var nextBtn = section.querySelector('[data-pcs-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });
    }

    updateClasses();
  })();

} catch (error) { console.warn("Muse source module premium-6", error); }
try {

(function () {
  var section = document.getElementById('premium-img-text-template--26315188830575__premium_img_text_jcLPBP');
  if (!section) return;

  var pitBtn = section.querySelector('.pit-button');
  if (pitBtn) {
    pitBtn.addEventListener('click', function(e) {
      var href = pitBtn.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        e.preventDefault();
        var target = document.querySelector('[aria-label="' + href.substring(1) + '"]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  var videos = section.querySelectorAll('video.pit-video');
  var button = section.querySelector('.patrol-video__button');

  if (!videos.length || !button) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction) {
    userAction = userAction || false;
    videos.forEach(function(video) {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(function() {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  button.addEventListener('click', function () {
    var anyPlaying = Array.prototype.some.call(videos, function(v) { return !v.paused; });
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var video = entry.target;
      if (video.dataset.userPaused === 'true') return;
      if (entry.isIntersecting) {
        video.play().catch(function() {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(function(video) { observer.observe(video); });
})();

} catch (error) { console.warn("Muse source module premium-7", error); }
try {

(function() {
  var sectionId = 'template--26315188830575__shop_testimonial_3mjR96';
  var section = document.querySelector('[data-shop-testimonial="' + sectionId + '"]');
  if (!section) section = document.querySelector('.testimonials-section');

  var track = section.querySelector('.testimonials__track');
  var bullets = section.querySelectorAll('.testimonials__bullet');

  if (!track || !bullets.length) return;

  function setActive(index) {
    bullets.forEach(function(bullet, i) {
      bullet.classList.toggle('is-active', i === index);
    });
  }

  function goToSlide(index) {
    if (index < 0 || index >= bullets.length) return;

    var card = section.querySelectorAll('.testimonial-card')[index];
    if (!card) return;

    /* Center the card within the track viewport */
    var targetLeft = card.offsetLeft - track.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    track.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });

    setActive(index);
  }

  bullets.forEach(function(bullet) {
    bullet.addEventListener('click', function() {
      goToSlide(parseInt(this.getAttribute('data-index'), 10));
    });
  });

  var scrollTimer;

  track.addEventListener('scroll', function() {
    clearTimeout(scrollTimer);

    scrollTimer = setTimeout(function() {
      var cards = section.querySelectorAll('.testimonial-card');
      var scrollCenter = track.scrollLeft + track.clientWidth / 2;

      /* Find the card whose center is closest to the viewport center */
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function(card, i) {
        var cardCenter = card.offsetLeft - track.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - scrollCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = i;
        }
      });

      setActive(nearestIndex);
    }, 80);
  });
})();

} catch (error) { console.warn("Muse source module premium-8", error); }
},
"athena":function(document,window){
try {

(function () {

  var buttons = document.querySelectorAll('.v1-hero .patrol-video__button');

  if (!buttons.length) return;

  buttons.forEach(function (button) {
    var root = button.closest('.v1-hero');
    var videos = root ? root.querySelectorAll('video') : [];

    if (!videos.length) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      paused ? 'Play background video' : 'Pause background video'
    );
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction = false) {
    videos.forEach(video => {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction = false) {
    videos.forEach(video => {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(() => {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  // button click
  button.addEventListener('click', function () {
    const anyPlaying = Array.from(videos).some(v => !v.paused);
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });
  // ⭐ IMPORTANT — prevent autoplay after scroll / visibility
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;

      if (video.dataset.userPaused === 'true') return;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(video => observer.observe(video));
  });
})();

} catch (error) { console.warn("Muse source module athena-1", error); }
try {

  // Replace Premium-M2-2024_1.jpg with new image on page load
(function() {
  const oldImagePattern = /Premium-M2-2024_1\.jpg/;
  const newImageUrl = 'https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSProduct-2-1.png?v=1761215892';
  
  function replaceImages() {
    // Get all images on the page
    const images = document.querySelectorAll('img');
    
    images.forEach(img => {
      // Check src attribute
      if (img.src && oldImagePattern.test(img.src)) {
        
        img.src = newImageUrl;
      }
      
      // Check srcset attribute
      if (img.srcset && oldImagePattern.test(img.srcset)) {
        
        img.srcset = newImageUrl;
      }
      
      // Check data-src (lazy loading)
      if (img.dataset.src && oldImagePattern.test(img.dataset.src)) {
        
        img.dataset.src = newImageUrl;
      }
    });
    
    // Also check background images in style attributes
    const elementsWithStyle = document.querySelectorAll('[style*="Premium-M2-2024_1.jpg"]');
    elementsWithStyle.forEach(el => {
      const style = el.getAttribute('style');
      if (style && oldImagePattern.test(style)) {
        
        const newStyle = style.replace(oldImagePattern, newImageUrl);
        el.setAttribute('style', newStyle);
      }
    });
  }
  
  // Replace on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceImages);
  } else {
    // DOM already loaded
    replaceImages();
  }
  
  // Watch for dynamically added images
  const observer = new MutationObserver(() => {
    replaceImages();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'style']
  });
})();

} catch (error) { console.warn("Muse source module athena-3", error); }
},
"muse-2":function(document,window){
try {

(function () {

  var buttons = document.querySelectorAll('.v1-hero .patrol-video__button');

  if (!buttons.length) return;

  buttons.forEach(function (button) {
    var root = button.closest('.v1-hero');
    var videos = root ? root.querySelectorAll('video') : [];

    if (!videos.length) return;

  function updateButtonState(paused) {
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      paused ? 'Play background video' : 'Pause background video'
    );
    button.classList.toggle('is-paused', paused);
  }

  function pauseAll(userAction = false) {
    videos.forEach(video => {
      video.pause();
      if (userAction) video.dataset.userPaused = 'true';
    });
    updateButtonState(true);
  }

  function playAll(userAction = false) {
    videos.forEach(video => {
      if (video.dataset.userPaused === 'true' && !userAction) return;
      video.play().catch(() => {});
      if (userAction) video.dataset.userPaused = 'false';
    });
    updateButtonState(false);
  }

  // button click
  button.addEventListener('click', function () {
    const anyPlaying = Array.from(videos).some(v => !v.paused);
    if (anyPlaying) {
      pauseAll(true);
    } else {
      playAll(true);
    }
  });
  // ⭐ IMPORTANT — prevent autoplay after scroll / visibility
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;

      if (video.dataset.userPaused === 'true') return;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach(video => observer.observe(video));
  });
})();

} catch (error) { console.warn("Muse source module muse-2-1", error); }
try {

  // Replace Premium-M2-2024_1.jpg with new image on page load
(function() {
  const oldImagePattern = /Premium-M2-2024_1\.jpg/;
  const newImageUrl = 'https://cdn.shopify.com/s/files/1/0348/7053/files/MuseSProduct-2-1.png?v=1761215892';
  
  function replaceImages() {
    // Get all images on the page
    const images = document.querySelectorAll('img');
    
    images.forEach(img => {
      // Check src attribute
      if (img.src && oldImagePattern.test(img.src)) {
        
        img.src = newImageUrl;
      }
      
      // Check srcset attribute
      if (img.srcset && oldImagePattern.test(img.srcset)) {
        
        img.srcset = newImageUrl;
      }
      
      // Check data-src (lazy loading)
      if (img.dataset.src && oldImagePattern.test(img.dataset.src)) {
        
        img.dataset.src = newImageUrl;
      }
    });
    
    // Also check background images in style attributes
    const elementsWithStyle = document.querySelectorAll('[style*="Premium-M2-2024_1.jpg"]');
    elementsWithStyle.forEach(el => {
      const style = el.getAttribute('style');
      if (style && oldImagePattern.test(style)) {
        
        const newStyle = style.replace(oldImagePattern, newImageUrl);
        el.setAttribute('style', newStyle);
      }
    });
  }
  
  // Replace on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceImages);
  } else {
    // DOM already loaded
    replaceImages();
  }
  
  // Watch for dynamically added images
  const observer = new MutationObserver(() => {
    replaceImages();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'style']
  });
})();

} catch (error) { console.warn("Muse source module muse-2-2", error); }
}
};
function scopedDocument(root,peers){
 peers=peers||[root];
 return {
  readyState:'complete', body:root, documentElement:root,
  get hidden(){return document.hidden;},
  querySelector:function(s){for(var i=0;i<peers.length;i++){var r=peers[i];var found=r.matches(s)?r:r.querySelector(s);if(found)return found;}return null;},
  querySelectorAll:function(s){return peers.reduce(function(all,r){return all.concat(Array.from(r.querySelectorAll(s)));},[]);},
  getElementById:function(id){return this.querySelector('[id="'+String(id).replace(/\"/g,'\\"')+'"]');},
  createElement:document.createElement.bind(document),
  addEventListener:function(type,fn,options){if(type==='DOMContentLoaded'){fn();}else{peers.forEach(function(r){r.addEventListener(type,fn,options);});}},
  dispatchEvent:root.dispatchEvent.bind(root)
 };
}
function initNativeMuse(root){
 if(root.dataset.ihMuseReady==='true')return;root.dataset.ihMuseReady='true';
 root.querySelectorAll('[data-ih-manufacturer-buy]').forEach(function(link){link.textContent='View program';});
 var key=root.dataset.ihMusePage||'home';
 var peers=Array.from(document.querySelectorAll('.ih-native-muse[data-ih-muse-page="'+key+'"]'));
 var leader=peers[0]||root;
 if(!leader.dataset.ihMuseModulesReady&&originalMuseModules[key]){leader.dataset.ihMuseModulesReady='true';originalMuseModules[key](scopedDocument(root,peers),window);}
 // Native source FAQ layout and all source rich-text answers are static, so
 // navigation and expansion work without calling the manufacturer's API.
 root.addEventListener('click',function(event){
  var faq=event.target.closest('.accordion-button');
  if(faq&&root.contains(faq)){
   event.preventDefault();var expanded=faq.getAttribute('aria-expanded')==='true';
   faq.setAttribute('aria-expanded',String(!expanded));
   var answer=root.querySelector('[id="'+faq.getAttribute('aria-controls')+'"]');
   if(answer)answer.style.display=expanded?'none':'block';
   return;
  }
  var heading=event.target.closest('.faq-section-title');
  if(heading){var items=heading.nextElementSibling;if(items){items.hidden=!items.hidden;heading.classList.toggle('active',!items.hidden);}return;}
  var buy=event.target.closest('[data-ih-manufacturer-buy]');
  if(buy){
   var view=buy.closest('[data-product-view]');
   if(!view&&root.dataset.ihMusePage==='home')view=document.querySelector('.ih-native-muse [data-product-view].is-active');
   if(view){var model=view.dataset.productView==='2'?'muse-2':'muse-s-athena';var variant=view.dataset.showcaseSelected||'bundle';
    var slug=model;if(variant==='bundle')slug=model==='muse-2'?'muse-2-premium-subscription-bundle':'muse-s-athena-premium-subscription-bundle-carbon';
    buy.href=document.documentElement.dataset.ihFocusRoute||'/#ih-service-focus';
   }return;
  }
  var media=event.target.closest('[data-media-target]');
  if(media&&media.closest('.v2-pdp-container')){
   event.preventDefault();var pdp=media.closest('.v2-pdp-container');var list=Array.from(pdp.querySelectorAll('[data-media-id]'));
   var current=list.findIndex(function(x){return x.dataset.active==='true';});var target=media.dataset.mediaTarget;
   var next=target==='+'?(current+1)%list.length:target==='-'?(current-1+list.length)%list.length:list.findIndex(function(x){return x.dataset.mediaId===target;});
   if(next<0)return;list.forEach(function(x,i){x.dataset.active=String(i===next);});
   pdp.querySelectorAll('[data-media-target]').forEach(function(x){if(x.dataset.mediaTarget!=='+'&&x.dataset.mediaTarget!=='-')x.dataset.active=String(x.dataset.mediaTarget===list[next].dataset.mediaId);});
   return;
  }
  var tab=event.target.closest('[data-tab-index],[data-tabslide-trigger]');
  if(tab){var slider=tab.closest('.v2-tab-slider');if(slider){
   var attr=tab.hasAttribute('data-tabslide-trigger')?'data-tabslide-index':'data-slide-index';var target=tab.dataset.tabslideTrigger||tab.dataset.tabIndex;
   slider.setAttribute('data-slide-current',target);
   slider.querySelectorAll('['+attr+']').forEach(function(x){x.setAttribute('data-slide-active',String(x.getAttribute(attr)===target));});
   slider.querySelectorAll('[data-tab-index],[data-tabslide-trigger]').forEach(function(x){x.setAttribute('aria-pressed',String((x.dataset.tabslideTrigger||x.dataset.tabIndex)===target));});
   return;
  }}
  var next=event.target.closest('[data-carousel-goto]');
  if(next){var carousel=next.closest('[data-carousel-current]');if(carousel){
   var n=Number(carousel.dataset.carouselMax)||carousel.querySelectorAll('[data-carousel-item]').length;var i=Number(carousel.dataset.carouselCurrent)||1;
   var target=next.dataset.carouselGoto==='next'?(i%n)+1:next.dataset.carouselGoto==='prev'?((i+n-2)%n)+1:Number(next.dataset.carouselGoto);
   carousel.dataset.carouselCurrent=String(target);
   carousel.querySelectorAll('[data-carousel-item]').forEach(function(x){x.setAttribute('data-carousel-item-active',String(Number(x.dataset.carouselItem)===target));});
   return;
  }}
  var video=event.target.closest('[data-video] video');if(video){event.preventDefault();if(video.paused)video.play().catch(function(){});else video.pause();}
 });
 root.querySelectorAll('video').forEach(function(v){
  v.muted=v.hasAttribute('muted');v.playsInline=true;
  if(v.autoplay)v.play().catch(function(){});
 });
 root.querySelectorAll('[data-logo-pause]').forEach(function(button){button.addEventListener('click',function(){
  var paused=button.getAttribute('aria-pressed')==='true';button.setAttribute('aria-pressed',String(!paused));
  var section=button.closest('.shopify-section');if(section)section.querySelectorAll('.v1-logo-strip__list').forEach(function(x){x.style.animationPlayState=paused?'running':'paused';});
 });});
 // Source fallback image lazy loading is fully local to these source modules.
 root.querySelectorAll('img[data-src]').forEach(function(img){if(!img.getAttribute('src')||img.getAttribute('src').indexOf('data:')===0)img.src=img.dataset.src;});
}
function initTrustpilotFrames(){
 document.querySelectorAll('.ih-native-muse iframe[data-ih-original-trustpilot]').forEach(function(frame,i){
  if(frame.dataset.ihWidgetReady)return;frame.dataset.ihWidgetReady='true';frame.dataset.ihWidgetId='ih-muse-trustpilot-'+i;
  function ready(){if(frame.contentWindow)frame.contentWindow.postMessage(JSON.stringify({command:'setId',widgetId:frame.dataset.ihWidgetId}),'https://widget.trustpilot.com');}
  frame.addEventListener('load',ready);ready();
 });
}
window.addEventListener('message',function(event){
 if(event.origin!=='https://widget.trustpilot.com')return;
 var frames=Array.from(document.querySelectorAll('.ih-native-muse iframe[data-ih-original-trustpilot]'));
 var frame=frames.find(function(f){return f.contentWindow===event.source;});if(!frame)return;
 var data;try{data=typeof event.data==='string'?JSON.parse(event.data):event.data;}catch(e){return;}
 if(!data||typeof data!=='object'||(data.widgetId&&data.widgetId!==frame.dataset.ihWidgetId))return;
 if(data.command==='resize-height'&&Number(data.height)>0&&Number(data.height)<20000)frame.style.height=Number(data.height)+'px';
 if(data.command==='setStyle'&&data.style){if(data.style.height)frame.style.height=data.style.height;if(data.style.minHeight)frame.style.minHeight=data.style.minHeight;}
 if(data.command==='loaded')frame.contentWindow.postMessage(JSON.stringify('loaded'),event.origin);
 if(data.command==='ping')frame.contentWindow.postMessage(JSON.stringify({command:'pong'}),event.origin);
});
// Frontrow's source quantitative widget waits for this documented message
// before revealing itself and sending its native height. Analytics messages
// are ignored; only source/origin-matched readiness and resize are handled.
window.addEventListener('message',function(event){
 if(event.origin!=='https://app.thefrontrowhealth.com')return;
 var frames=Array.from(document.querySelectorAll('.ih-native-muse iframe.iframe-frontrow'));
 var frame=frames.find(function(f){return f.contentWindow===event.source;});if(!frame)return;
 var data=event.data;
 if(data&&typeof data==='object'&&data.name==='QUANT_REQUEST_READY_STATUS')event.source.postMessage({name:'PARENT_READY'},event.origin);
 if(data&&typeof data==='object'&&data.name==='RESIZE_HEIGHT'&&Number(data.value)>=0&&Number(data.value)<2000)frame.style.height=Number(data.value)+'px';
 if(data==='SCROLL_TO_TESTIMONIALS'){
  var root=frame.closest('.ih-native-muse');var reviews=root.querySelector('.trustpilot-widget');if(reviews)reviews.scrollIntoView({behavior:'smooth',block:'start'});
 }
});
function init(){document.querySelectorAll('.ih-native-muse').forEach(initNativeMuse);initTrustpilotFrames();
 document.querySelectorAll('.ih-native-muse iframe.iframe-frontrow').forEach(function(frame){
  if(frame.dataset.ihFrontrowReady)return;frame.dataset.ihFrontrowReady='true';
  frame.addEventListener('load',function(){frame.contentWindow.postMessage({name:'PARENT_READY'},'https://app.thefrontrowhealth.com');});
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
window.ihInitNativeMuse=init;
})();
